<template>
  <div class="yuklama-page">
    <div class="page-header">
      <div class="breadcrumb">
        <span class="crumb-link" @click="$router.push('/')">Asosiy</span>
        <span class="separator">/</span>
        <span class="crumb-link" @click="$router.back()">Kafedra yuklamalari</span>
        <span class="separator">/</span>
        <span class="crumb-current">{{ kafedraName || "Kafedra" }}</span>
        <span class="separator" v-if="filters.oquvYili">/</span>
        <span class="crumb-current" v-if="filters.oquvYili">{{ filters.oquvYili }}</span>
        <span class="separator" v-if="filters.semestrTuri">/</span>
        <span class="crumb-current" v-if="filters.semestrTuri">{{ filters.semestrTuri === 'kuzgi' ? 'Kuzgi' : filters.semestrTuri === 'bahorgi' ? 'Bahorgi' : 'Hammasi' }} semestr</span>
      </div>
    </div>

    <div class="actions-row">
      <div class="filters-group">
  <input type="text" class="filter-input" v-model="filters.oquvYili" placeholder="O'quv yili (e.g., 2026-2027)" @keyup.enter="applyYearFilter" />
        <button class="filter-btn" :class="{ active: filters.semestrTuri === '' }" @click="setSemester('')">Hammasi</button>
  <button class="filter-btn" :class="{ active: filters.semestrTuri === 'kuzgi' }" @click="setSemester('kuzgi')">Kuzgi</button>
  <button class="filter-btn" :class="{ active: filters.semestrTuri === 'bahorgi' }" @click="setSemester('bahorgi')">Bahorgi</button>
</div>

      <button class="btn-export" @click="exportToExcel">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 6px;">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        Export yuklama
      </button>
    </div>

    <!-- 🔍 FILTRLAR PANELI (Fanlar, Fakultet, Yo'nalish, Guruh nomi, Kurs) -->
    <div class="table-filters-card">
      <!-- 1. Fanlar filtri -->
      <div class="filter-field-item grow-item">
        <label class="filter-field-label">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
          Fanlar
        </label>
        <div class="filter-input-wrapper">
          <svg class="search-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          <input
            type="text"
            v-model="filters.fan"
            placeholder="Fan nomi yoki kodi..."
            class="filter-text-input"
          />
          <button v-if="filters.fan" class="filter-clear-icon-btn" @click="filters.fan = ''" title="Tozalash">✕</button>
        </div>
      </div>

      <!-- 2. Fakultet filtri -->
      <div class="filter-field-item">
        <label class="filter-field-label">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
          Fakultet
        </label>
        <select v-model="filters.fakultet" class="filter-select-control">
          <option value="">Barchasi</option>
          <option v-for="fak in availableFaculties" :key="fak" :value="fak">{{ fak }}</option>
        </select>
      </div>

      <!-- 3. Ta'lim yo'nalishi filtri -->
      <div class="filter-field-item grow-item">
        <label class="filter-field-label">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
          Ta'lim yo'nalishi
        </label>
        <select v-model="filters.yonilish" class="filter-select-control" style="max-width: 100%;">
          <option value="">Barchasi</option>
          <option v-for="sp in availableSpecialties" :key="sp" :value="sp">{{ sp }}</option>
        </select>
      </div>

      <!-- 4. Guruh nomi filtri -->
      <div class="filter-field-item">
        <label class="filter-field-label">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
          Guruh nomi
        </label>
        <select v-model="filters.guruh" class="filter-select-control">
          <option value="">Barchasi</option>
          <option v-for="g in availableGroupsList" :key="g" :value="g">{{ g }}</option>
        </select>
      </div>

      <!-- 5. Kurs filtri -->
      <div class="filter-field-item">
        <label class="filter-field-label">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
          Kurs
        </label>
        <div class="kurs-pills-container">
          <button class="kurs-pill-btn" :class="{ active: filters.kurs === '' }" @click="filters.kurs = ''">Barchasi</button>
          <button v-for="k in availableCourses" :key="k" class="kurs-pill-btn" :class="{ active: String(filters.kurs) === String(k) }" @click="filters.kurs = String(k)">{{ k }}-kurs</button>
        </div>
      </div>

      <!-- Filtrlarni tozalash tugmasi -->
      <button v-if="hasActiveFilters" class="btn-reset-all-filters" @click="resetFilters" title="Filtrlarni tozalash">
        ✕ Tozalash
      </button>

      <div class="filter-count-badge">
        <span v-if="hasActiveFilters">Filtrlangan: <strong>{{ displayRows.length }}</strong> ta fan (Jami: {{ totalRowsCount }})</span>
        <span v-else>Jami: <strong>{{ totalRowsCount }}</strong> ta fan</span>
      </div>
    </div>

    <div class="table-wrapper">
      <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
        <span>Ma'lumotlar yuklanmoqda...</span>
      </div>

      <div class="table-scroll">
        <table class="yuklama-table" ref="yuklamaTable">
          <thead>
            <tr>
              <th rowspan="3" class="th-base th-num">#</th>
              <th rowspan="3" class="th-base th-fan" :class="{ 'th-filtered': !!filters.fan }">Fanlar</th>
              <th rowspan="3" class="th-base th-fak" :class="{ 'th-filtered': !!filters.fakultet }">Fakultet</th>
              <th rowspan="3" class="th-base th-yon" :class="{ 'th-filtered': !!filters.yonilish }">Ta'lim yo'nalishi</th>
              <th rowspan="3" class="th-base th-guruh-nomi" :class="{ 'th-filtered': !!filters.guruh }">Guruh nomi</th>
              <th rowspan="3" class="th-base" :class="{ 'th-filtered': !!filters.kurs }"><div class="vertical-text">Kurs</div></th>
              <th rowspan="3" class="th-base"><div class="vertical-text">Talaba soni</div></th>
              <th rowspan="3" class="th-base"><div class="vertical-text">Oqim soni</div></th>
              <th rowspan="3" class="th-base"><div class="vertical-text">Guruh soni</div></th>
              <th rowspan="3" class="th-base"><div class="vertical-text">Kichik guruh soni</div></th>

              <th colspan="5" class="th-group th-audit">Auditoriya mashg'uloti</th>
              <th colspan="22" class="th-group th-tashqari">Auditoriyadan tashqari mashg'ulotlar</th>
              <th rowspan="3" class="th-base"><div class="vertical-text">Jami</div></th>
            </tr>
            <tr>
              <th rowspan="2" class="th-base th-audit-cell"><div class="vertical-text">Ma'ruza</div></th>
              <th rowspan="2" class="th-base th-audit-cell"><div class="vertical-text">Amaliy mashg'ulot</div></th>
              <th rowspan="2" class="th-base th-audit-cell"><div class="vertical-text">Semenar mashg'ulot</div></th>
              <th rowspan="2" class="th-base th-audit-cell"><div class="vertical-text">Laboratoriya mashg'ulot</div></th>
              <th rowspan="2" class="th-base th-audit-cell th-jami"><div class="vertical-text">Jami auditoriya soati</div></th>
              
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Kurs ishi(Talaba soni*2)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Kurs ishi himoyasi (Talaba soni*0,4)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Kurs loyihasi (Talaba soni*3)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Kurs loyihasi himoyasi (Talaba soni*0,6)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Hisob chizma ishi (Talaba soni*0,3)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Oraliq nazorat (Talaba soni*0,2)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Yakuniy nazorat (Talaba soni*0,3)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Malakaviy amaliyot individual (talaba soni*2)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Malakaviy amaliyot universitet hududida (3*6*hafta soni*guruh soni)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Malakaviy amaliyot universitetdan tashqari hududda (6*6*hafta soni*guruh soni)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">BMI rahbarlik (Boshqa ta'lim yo'nalishlari talaba soni*25, texnik yo'nalishlarga talaba soni*30)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">BMI/DAK (Talaba soni*0,4)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Magistrlik IPF va amaliyotga rahbarlik (Talaba soni*50)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">MD - ITI ga rahbarlik qilish (Talaba soni*50)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">MD/DAK (Talaba soni*0,8)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Doktorantga (stajyor tadqiqotchiga talaba soni*75) rahbarlik Talaba soni*100)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">YaDA yozma ish guruh soni*3</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">YaDA yozma ish tekshirish uchun talaba soni*0,2</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">YaDA test guruh soni*1</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Ochiq leksiya (dars soni soni*5)</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell"><div class="vertical-text">Respublika ta'lim muassasalarida markazlarida malaka oshirishlarni o'tash</div></th>
              <th rowspan="2" class="th-base th-tashqari-cell th-jami"><div class="vertical-text">Jami auditoriyadan tashqari soat</div></th>
            </tr>
            <tr></tr>
          </thead>
          <tbody>
            <tr v-if="!loading && displayRows.length === 0">
              <td colspan="39" class="td-empty">Ma'lumot topilmadi</td>
            </tr>
            <tr
              v-for="(row, i) in displayRows"
              :key="row._id || row.itemId || ('row_' + i)"
              class="data-row"
              :class="{ 'row-secondary': row.isSyntheticGroup, 'row-primary': row.isPrimaryStream }">
              <td class="td-center td-num">
                {{ (currentPage - 1) * limit + i + 1 }}
              </td>
              <td class="td-left td-fan">
                <button
                  v-if="row.isCustom && isSuperAdmin"
                  class="btn-delete-row"
                  @click.stop="confirmDeleteRow(row)"
                  title="Qatorni o'chirish"
                >
                  ✕
                </button>
                {{ getSubjectNameDisplay(row) }}
                <span class="fan-code" v-if="getSubjectCodeDisplay(row)">| {{ getSubjectCodeDisplay(row) }}</span>
                <span class="sem-badge" v-if="row.semester?.name || row.semestrTuri" style="font-size: 11px; color: #1e40af; background: #e0e7ff; padding: 2px 6px; border-radius: 4px; margin-left: 6px; font-weight: 600; display: inline-block;">
                  {{ row.semester?.name || (row.semestrTuri === 'kuzgi' ? 'Kuzgi' : 'Bahorgi') }}
                </span>
              </td>
              <td class="td-left" :class="{'readonly-cell': row.isCustom}" @click="row.isCustom && openEditModal(row, 'customFaculty', 'Fakultet nomini kiriting', 'text')">{{ row.faculty?.name || row.customFaculty || row.specialty?.name || "—" }}</td>
              <td class="td-left td-yon" :class="{'readonly-cell': row.isCustom}" @click="row.isCustom && openEditModal(row, 'customSpecialty', 'Ta\'lim yo\'nalishini kiriting', 'text')">{{ getRowSpecialty(row) || "—" }}</td>
              <td class="td-center td-guruh-nomi readonly-cell" >{{ getFullGuruhNomi(row) }}</td>
              <td class="td-center" :class="{'readonly-cell': row.isCustom}" @click="row.isCustom && openEditModal(row, 'customKurs', 'Kursni kiriting')">{{ row.customKurs || getKurs(row) }}</td>
              <td class="td-center" @click="openEditModal(row, 'talabalarSoni', 'Talabalar sonini kiriting', 'number')">
                {{ (row.guruhNomi || row.isCustom) ? (row.talabalarSoni || 0) : 0 }}
              </td>
              <td class="td-center" @click="openEditModal(row, 'oqimSoni', 'Oqim sonini kiriting', 'number')">{{ row.oqimSoni || row.oqim || 0 }}</td>
              <td class="td-center" @click="openEditModal(row, 'guruhSoni', 'Guruh sonini kiriting', 'number')">
                {{ (row.guruhNomi || row.isCustom) ? (row.guruhSoni || (row.guruhNomi ? splitGroupNames(row.guruhNomi).length : 0)) : 0 }}
              </td>
              <td class="td-center" @click="openEditModal(row, 'kichikGuruhSoni', 'Kichik guruh sonini kiriting', 'number')">
                {{ (row.guruhNomi || row.isCustom) ? (row.kichikGuruhSoni || (row.guruhNomi ? splitGroupNames(row.guruhNomi).length : 0)) : 0 }}
              </td>

              <td class="td-center td-audit td-maruza" @click="openTeacherModal(row, 'maruza')" :class="{ 'td-amaliy-multiplied': row.guruhNomi && row.guruhNomi.split(',').length > 1 }">{{ getRemaining(row, 'maruza', calc(row).audit.maruza) }}</td>
              <td class="td-center td-audit td-amaliy" @click="openTeacherModal(row, 'amaliy')" :class="{ 'td-amaliy-multiplied': row.guruhNomi && row.guruhNomi.split(',').length > 1 }">{{ getRemaining(row, 'amaliy', calc(row).audit.amaliy) }}</td>
              <td class="td-center td-audit" @click="openTeacherModal(row, 'seminar')">{{ getRemaining(row, 'seminar', calc(row).audit.seminar) }}</td>
              <td class="td-center td-audit" :class="{ 'td-lab-multiplied': row.kichikGuruhSoni > 1 && calc(row).audit.laboratoriya > 0 }" @click="openTeacherModal(row, 'laboratoriya')">{{ getRemaining(row, 'laboratoriya', calc(row).audit.laboratoriya) }}</td>
              <td class="td-center td-audit td-jami-val">
                {{ Number((getRemaining(row, 'maruza', calc(row).audit.maruza) + getRemaining(row, 'amaliy', calc(row).audit.amaliy) + getRemaining(row, 'seminar', calc(row).audit.seminar) + getRemaining(row, 'laboratoriya', calc(row).audit.laboratoriya)).toFixed(1)) }}
              </td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'kursIshi', 'Kurs ishi (Talaba soni*2)')">{{ getRemaining(row, 'kursIshi', calc(row).kursIshi) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'kursIshiHimoya', 'Kurs ishi himoyasi (Talaba soni*0,4)')">{{ getRemaining(row, 'kursIshiHimoya', calc(row).kursIshiHimoya) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'kursLoyihasi', 'Kurs loyihasi (Talaba soni*3)')">{{ getRemaining(row, 'kursLoyihasi', calc(row).kursLoyihasi) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'kursLoyihasiHimoya', 'Kurs loyihasi himoyasi (Talaba soni*0,6)')">{{ getRemaining(row, 'kursLoyihasiHimoya', calc(row).kursLoyihasiHimoya) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'hisobChizma', 'Hisob chizma ishi (Talaba soni*0,3)')">{{ getRemaining(row, 'hisobChizma', calc(row).hisobChizma) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'oraliq', 'Oraliq nazorat (Talaba soni*0,2)')">{{ getRemaining(row, 'oraliq', calc(row).oraliq) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'yakuniy', 'Yakuniy nazorat (Talaba soni*0,3)')">{{ getRemaining(row, 'yakuniy', calc(row).yakuniy) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'amaliyotInd', 'Malakaviy amaliyot individual (talaba soni*2)')">{{ getRemaining(row, 'amaliyotInd', calc(row).amaliyotInd) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'amaliyotUni', 'Malakaviy amaliyot universitet hududida (3*6*hafta soni*guruh soni)')">{{ getRemaining(row, 'amaliyotUni', calc(row).amaliyotUni) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'amaliyotTash', 'Malakaviy amaliyot universitetdan tashqari hududda (6*6*hafta soni*guruh soni)')">{{ getRemaining(row, 'amaliyotTash', calc(row).amaliyotTash) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'bmiRahbar', 'BMI rahbarlik (talaba soni*25 yoki *30)')">{{ getRemaining(row, 'bmiRahbar', calc(row).bmiRahbar) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'bmiDak', 'BMI/DAK (Talaba soni*0,4)')">{{ getRemaining(row, 'bmiDak', calc(row).bmiDak) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'magistr', 'Magistrlik IPF va amaliyotga rahbarlik (Talaba soni*50)')">{{ getRemaining(row, 'magistr', calc(row).magistr) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'mdIti', 'MD - ITI ga rahbarlik qilish (Talaba soni*50)')">{{ getRemaining(row, 'mdIti', calc(row).mdIti) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'mdDak', 'MD/DAK (Talaba soni*0,8)')">{{ getRemaining(row, 'mdDak', calc(row).mdDak) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'doktorant', 'Doktorantga rahbarlik (Talaba soni*100)')">{{ getRemaining(row, 'doktorant', calc(row).doktorant) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'yadaYozmaGuruh', 'YaDA yozma ish (guruh soni*3)')">{{ getRemaining(row, 'yadaYozmaGuruh', calc(row).yadaYozmaGuruh) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'yadaYozmaTalaba', 'YaDA yozma ish tekshirish (talaba soni*0,2)')">{{ getRemaining(row, 'yadaYozmaTalaba', calc(row).yadaYozmaTalaba) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'yadaTest', 'YaDA test (guruh soni*1)')">{{ getRemaining(row, 'yadaTest', calc(row).yadaTest) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'ochiqLeksiya', 'Ochiq leksiya (dars soni*5)')">{{ getRemaining(row, 'ochiqLeksiya', calc(row).ochiqLeksiya) }}</td>
              <td class="td-center td-tashqari readonly-cell" @click="openTashqariModal(row, 'malakaOshirish', 'Respublika ta\'lim muassasalarida markazlarida malaka oshirishlarni o\'tash')">{{ getRemaining(row, 'malakaOshirish', calc(row).malakaOshirish) }}</td>
              <td class="td-center td-tashqari td-jami-val">{{ calc(row).jamiTashqari }}</td>
              <td class="td-center td-jami-val">{{ calc(row).jami }}</td>
            </tr>
          </tbody>
          <tfoot v-if="rows.length > 0">
            <tr class="totals-row totals-row-jami">
              <td class="td-center td-total-label" colspan="10">Jami</td>
              <td class="td-center td-total td-audit">{{ totals.maruza }}</td>
              <td class="td-center td-total td-audit">{{ totals.amaliy }}</td>
              <td class="td-center td-total td-audit">{{ totals.seminar }}</td>
              <td class="td-center td-total td-audit">{{ totals.laboratoriya }}</td>
              <td class="td-center td-total td-audit td-jami-val">{{ totals.jamiAudit }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.kursIshi }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.kursIshiHimoya }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.kursLoyihasi }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.kursLoyihasiHimoya }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.hisobChizma }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.oraliq }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.yakuniy }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.amaliyotInd }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.amaliyotUni }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.amaliyotTash }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.bmiRahbar }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.bmiDak }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.magistr }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.mdIti }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.mdDak }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.doktorant }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.yadaYozmaGuruh }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.yadaYozmaTalaba }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.yadaTest }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.ochiqLeksiya }}</td>
              <td class="td-center td-total td-tashqari">{{ totals.malakaOshirish }}</td>
              <td class="td-center td-total td-tashqari td-jami-val">{{ totals.jamiTashqari }}</td>
              <td class="td-center td-total td-jami-val">{{ totals.jami }}</td>
            </tr>
            <tr class="totals-row totals-row-remaining">
              <td class="td-center td-total-label td-remaining-label" colspan="10">Qoldiqlar</td>
              <td class="td-center td-total td-audit">{{ remainingTotals.maruza }}</td>
              <td class="td-center td-total td-audit">{{ remainingTotals.amaliy }}</td>
              <td class="td-center td-total td-audit">{{ remainingTotals.seminar }}</td>
              <td class="td-center td-total td-audit">{{ remainingTotals.laboratoriya }}</td>
              <td class="td-center td-total td-audit td-jami-val">{{ remainingTotals.jamiAudit }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.kursIshi }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.kursIshiHimoya }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.kursLoyihasi }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.kursLoyihasiHimoya }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.hisobChizma }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.oraliq }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.yakuniy }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.amaliyotInd }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.amaliyotUni }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.amaliyotTash }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.bmiRahbar }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.bmiDak }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.magistr }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.mdIti }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.mdDak }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.doktorant }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.yadaYozmaGuruh }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.yadaYozmaTalaba }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.yadaTest }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.ochiqLeksiya }}</td>
              <td class="td-center td-total td-tashqari">{{ remainingTotals.malakaOshirish }}</td>
              <td class="td-center td-total td-tashqari td-jami-val">{{ remainingTotals.jamiTashqari }}</td>
              <td class="td-center td-total td-jami-val">{{ remainingTotals.jami }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="pagination" v-if="displayRows.length > 0">
        <span class="total-info">Jami: {{ displayRows.length }} ta</span>
        <div class="page-btns">
          <button
            @click="changePage(currentPage - 1)"
            :disabled="currentPage === 1"
            class="page-btn">
            ‹
          </button>
          <span class="page-info">{{ currentPage }} / {{ pageCount }}</span>
          <button
            @click="changePage(currentPage + 1)"
            :disabled="currentPage >= pageCount"
            class="page-btn">
            ›
          </button>
        </div>
      </div>

      <!-- Add Custom Workload Section -->
      <div class="custom-workload-section" v-if="isEditable">
        <h4 class="cw-title">Qo'shimcha yuklama qo'shish</h4>
        <div class="cw-controls">
          <select v-model="selectedCustomWorkload" class="filter-select cw-select">
            <option value="">Yuklama turini tanlang...</option>
            <option value="amaliyotInd">Malakaviy amaliyot individual</option>
            <option value="amaliyotUni">Malakaviy amaliyot universitet hududida</option>
            <option value="amaliyotTash">Malakaviy amaliyot universitetdan tashqari hududda</option>
            <option value="bmiRahbar">BMI rahbarlik</option>
            <option value="bmiDak">BMI/DAK</option>
            <option value="magistr">Magistrlik IPF va amaliyotga rahbarlik</option>
            <option value="mdIti">MD - ITI ga rahbarlik qilish</option>
            <option value="mdDak">MD/DAK</option>
            <option value="doktorant">Doktorantga (stajyor tadqiqotchiga) rahbarlik</option>
            <option value="yadaYozmaGuruh">YaDA yozma ish guruh soni</option>
            <option value="yadaYozmaTalaba">YaDA yozma ish tekshirish</option>
            <option value="yadaTest">YaDA test</option>
            <option value="ochiqLeksiya">Ochiq leksiya</option>
            <option value="malakaOshirish">Respublika ta'lim muassasalarida markazlarida malaka oshirishlarni o'tash</option>
          </select>
          <button class="btn-export btn-add-custom" @click="addCustomWorkload" :disabled="!selectedCustomWorkload || addingCustom">
            <span v-if="addingCustom">Qo'shilmoqda...</span>
            <span v-else>+ Jadvalga qo'shish</span>
          </button>
        </div>
      </div>
    </div>

        <!-- Teacher Assignment Modal -->
    <div v-if="showModal" class="tm-overlay" @click.self="closeModal">
      <div class="tm-modal">
        <!-- Header with gradient -->
        <div class="tm-header">
          <div class="tm-header-left">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <h3>Xodimlarni biriktirish</h3>
          </div>
          <button class="tm-close" @click="closeModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <!-- Stats bar -->
        <div class="tm-stats">
          <div class="tm-stat-item">
            <span class="tm-stat-icon">📊</span>
            <div class="tm-stat-info">
              <span class="tm-stat-num">{{ modalTotalHours }}</span>
              <span class="tm-stat-text">Umumiy soat</span>
            </div>
          </div>
          <div class="tm-stat-divider"></div>
          <div class="tm-stat-item">
            <span class="tm-stat-icon">⏳</span>
            <div class="tm-stat-info">
              <span class="tm-stat-num" :class="{'tm-danger': remainingHours < 0}">{{ remainingHours }}</span>
              <span class="tm-stat-text">Qolgan soat</span>
            </div>
          </div>
          <div class="tm-stat-divider"></div>
          <div class="tm-stat-item">
            <span class="tm-stat-icon">👥</span>
            <div class="tm-stat-info">
              <span class="tm-stat-num">{{ currentAssignments.length }}</span>
              <span class="tm-stat-text">Biriktirilgan</span>
            </div>
          </div>
        </div>

        <!-- Body -->
        <div class="tm-body">
          <!-- Existing assignments -->
          <div v-if="currentAssignments.length > 0" class="tm-section-label">Biriktirilgan xodimlar</div>
          <div class="tm-card" v-for="(assignment, idx) in currentAssignments" :key="'a'+idx">
            <div class="tm-card-main">
              <div class="tm-avatar">{{ (assignment.employeeName || '?').charAt(0) }}</div>
              <div class="tm-card-info">
                <span class="tm-card-name">{{ assignment.employeeName }}</span>
                <span class="tm-card-meta">{{ assignment.isSoatbay ? 'Soatbay' : 'Shtatli' }} · {{ assignment.hours }} soat</span>
              </div>
            </div>
            <div class="tm-card-actions">
              <span v-if="isAssignmentLocked(assignment)" class="tm-locked-badge" title="O'quv ishlari bo'yicha prorektor tasdiqlagan - bloklangan">
                🔒 Tasdiqlangan
              </span>
              <template v-else>
                <button class="tm-action-btn tm-edit" @click="editAssignment(idx)" title="Tahrirlash">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                </button>
                <button class="tm-action-btn tm-delete" @click="removeAssignment(idx)" title="O'chirish">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                </button>
              </template>
            </div>
          </div>

          <!-- New assignment form -->
          <div class="tm-section-label" style="margin-top:16px">Yangi xodim biriktirish</div>
          <div class="tm-new-form">
            <div class="tm-form-row">
              <div class="tm-form-group tm-form-emp">
                <label class="tm-label">Xodim</label>
                <select v-model="teacherForm.employeeId" class="tm-select">
                  <option value="">Xodimni tanlang...</option>
                  <option 
                    v-for="emp in employees" 
                    :key="emp.distinct_id || emp.meta_id || emp._id || emp.employee_id_number || emp.id" 
                    :value="emp.distinct_id || emp.id || emp.employee_id_number"
                    :disabled="isTeacherLocked(emp)"
                  >
                    {{ emp.full_name || emp.name }} {{ emp.employmentStaff?.name ? '(' + emp.employmentStaff.name + (emp.staffPosition?.name ? ' · ' + emp.staffPosition.name : '') + ')' : '' }}{{ isTeacherLocked(emp) ? ' — 🔒 (O\'quv prorektori tasdiqlagan)' : '' }}
                  </option>
                </select>
                <div v-if="selectedTeacherIsLocked" style="color: #ef4444; font-size: 12px; margin-top: 4px; font-weight: 500;">
                  🔒 O'quv ishlari bo'yicha prorektor tasdiqlagan! Ushbu o'qituvchiga yangi fan biriktirib bo'lmaydi.
                </div>
              </div>
              <div class="tm-form-group tm-form-hours">
                <label class="tm-label">Soat</label>
                <input 
                  type="number" 
                  v-model.number="teacherForm.hours" 
                  class="tm-input" 
                  placeholder="0" 
                  :max="remainingHours > 0 ? remainingHours : 0" 
                  min="0"
                  step="0.1"
                  @input="validateTeacherHours"
                />
              </div>
            </div>
            <div class="tm-form-row-bottom">
              <label class="tm-checkbox-wrap">
                <input type="checkbox" v-model="teacherForm.isSoatbay" />
                <span class="tm-check-box"></span>
                <span>Soatbay</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="tm-footer">
          <button class="tm-btn tm-btn-cancel" @click="closeModal">Yopish</button>
          <button class="tm-btn tm-btn-save" @click="handleSaqlash">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
            Saqlash
          </button>
        </div>
      </div>
    </div>

        

  </div>
</template>

<script>
import axios from "axios";

const API = process.env.VUE_APP_API_URL;

export default {
  name: "TaqsimotJadval",
  computed: {
    remainingHours() {
      const assigned = this.currentAssignments.reduce((acc, curr) => acc + (curr.hours || 0), 0);
      return Number((this.modalTotalHours - assigned).toFixed(1));
    },

    selectedTeacherIsLocked() {
      if (!this.teacherForm.employeeId) return false;
      const emp = (this.employees || []).find(e => 
        String(e.distinct_id || e.id || e.employee_id_number) === String(this.teacherForm.employeeId)
      );
      return this.isTeacherLocked(emp);
    },

    unfilteredDisplayRows() {
      const getGroupBase = (str) => {
        if (!str) return "";
        let clean = str.replace(/\b(19|20)\d{2}\b/g, '');
        return clean.replace(/[^a-z0-9]/gi, '').toLowerCase();
      };

      const getSubjectBase = (r) => {
        if (!r) return "";
        let name = "";
        if (r.subject) {
          if (typeof r.subject === 'object') {
            const sObj = Array.isArray(r.subject) ? r.subject[0] : r.subject;
            name = sObj?.name || sObj?.title || sObj?.subjectName || "";
          } else if (typeof r.subject === 'string' && !/^[0-9a-fA-F]{24}$/.test(r.subject)) {
            name = r.subject;
          }
        }
        if (!name && r.subjectDetails) {
          const sdObj = Array.isArray(r.subjectDetails) ? r.subjectDetails[0] : r.subjectDetails;
          name = sdObj?.name || sdObj?.title || sdObj?.subjectName || "";
        }
        if (!name && r.subjectName) name = r.subjectName;
        if (!name && r.customSubject) name = r.customSubject;
        if (!name && r.name) name = r.name;
        if (!name && r.fanNomi) name = r.fanNomi;

        const base = (name || "")
          .replace(/\u0430/g,'a').replace(/\u0410/g,'A')
          .replace(/\u0435/g,'e').replace(/\u0415/g,'E')
          .replace(/\u043E/g,'o').replace(/\u041E/g,'O')
          .replace(/\u0441/g,'c').replace(/\u0421/g,'C')
          .replace(/\u0440/g,'r').replace(/\u0420/g,'R')
          .replace(/\u0445/g,'x').replace(/\u0425/g,'X')
          .replace(/\|.*/g, '')
          .replace(/\((?!kurs)[A-Z0-9\s-]+\)/gi, '')
          .replace(/\b[A-Z]{2,6}\d{2,6}\b/gi, '')
          .replace(/[^a-z]/gi, '')
          .toLowerCase();

        return isKurs(r) ? `${base}_kurs` : base;
      };

      const isKurs = (r) => {
        let n = "";
        if (typeof r?.subject === 'object') n = r.subject?.name || "";
        if (!n) n = r?.subjectName || r?.fanNomi || r?.name || "";
        return /kurs\s*(ishi|loyihasi?)/i.test(n);
      };

      const sameSubject = (r1, r2) => {
        if (!r1 || !r2) return false;
        if (isKurs(r1) !== isKurs(r2)) return false;

        // Try ID match first (most reliable)
        const id1 = typeof r1.subject === 'object' ? (r1.subject?._id || r1.subject?.id) : (typeof r1.subject === 'string' ? r1.subject : "");
        const id2 = typeof r2.subject === 'object' ? (r2.subject?._id || r2.subject?.id) : (typeof r2.subject === 'string' ? r2.subject : "");
        if (id1 && id2 && String(id1) === String(id2)) return true;

        // Try code match
        const code1 = typeof r1.subject === 'object' ? (r1.subject?.code || "") : (r1.subjectCode || "");
        const code2 = typeof r2.subject === 'object' ? (r2.subject?.code || "") : (r2.subjectCode || "");
        if (code1 && code2 && String(code1).toLowerCase().trim() === String(code2).toLowerCase().trim()) return true;

        // Fall back to name comparison
        const sBase1 = getSubjectBase(r1);
        const sBase2 = getSubjectBase(r2);
        if (sBase1 && sBase2) return sBase1 === sBase2;

        return false;
      };

      const sameSemester = (r1, r2) => {
        const sem1 = r1.semester?.code || r1.semestrTuri;
        const sem2 = r2.semester?.code || r2.semestrTuri;
        if (!sem1 || !sem2) return true;
        return String(sem1) === String(sem2);
      };

      const sameEducationForm = (r1, r2) => {
        const f1 = r1.educationForm?.code || r1.educationForm?.name;
        const f2 = r2.educationForm?.code || r2.educationForm?.name;
        if (!f1 || !f2) return true;
        return String(f1) === String(f2);
      };

      const combinedRows = [];

      this.rows.forEach(r => {
        if (!r.guruhNomi) return;
        const rawList = this.splitGroupNames(r.guruhNomi);
        if (rawList.length > 1) {
          const subjectBase = getSubjectBase(r);
          const baseGroups = rawList.map(g => getGroupBase(g)).filter(Boolean);
          combinedRows.push({
            row: r,
            subjectBase,
            baseGroupsSet: new Set(baseGroups),
            baseGroupsList: baseGroups
          });
        }
      });

      // Dynamically mark single-group rows that are secondary attached groups of a stream
      this.rows.forEach(r => {
        if (!r.guruhNomi) return;
        const rList = this.splitGroupNames(r.guruhNomi);
        
        if (rList.length > 1) {
          r.isPrimaryStream = true;
          r._isSecondaryInStream = false;
          delete r.isSyntheticGroup;
          return;
        } else {
          delete r.isPrimaryStream;
        }

        const isSecondaryInStream = combinedRows.some(c => {
          if (c.row === r) return false;
          if (!sameSubject(r, c.row)) return false;
          if (!sameSemester(r, c.row)) return false;
          if (!sameEducationForm(r, c.row)) return false;
          const cList = this.splitGroupNames(c.row.guruhNomi);
          for (let i = 1; i < cList.length; i++) {
            if (getGroupBase(cList[i]) === getGroupBase(rList[0])) return true;
          }
          return false;
        });

        r._isSecondaryInStream = isSecondaryInStream;

        if (isSecondaryInStream) {
          r.isSyntheticGroup = true;
        } else if (r.isSyntheticGroup) {
          delete r.isSyntheticGroup;
        }
      });

      const filtered = this.rows.filter(r => {
        const hasPositiveHours = (
          r.maruza > 0 || r.seminar > 0 || r.amaliy > 0 || r.laboratoriya > 0 ||
          r.kursIshi > 0 || r.kursIshiHimoya > 0 || r.oraliq > 0 || r.yakuniy > 0 || r.boshqaTashqari > 0
        );
        if (r.isSyntheticGroup || r._isSecondaryInStream || hasPositiveHours || r.isCustom) return true;
        if (!r.guruhNomi) return true;
        const rRawList = this.splitGroupNames(r.guruhNomi);
        if (rRawList.length === 0) return true;

        const rBaseGroups = rRawList.map(g => getGroupBase(g)).filter(Boolean);

        const isMergedIntoAnotherRow = combinedRows.some(c => {
          if (c.row === r) return false;

          if (!sameSemester(r, c.row)) return false;
          if (!sameEducationForm(r, c.row)) return false;
          if (!sameSubject(r, c.row)) return false;

          return rBaseGroups.every(rgBase => {
            if (c.baseGroupsSet.has(rgBase)) return true;
            return c.baseGroupsList.some(cgBase => {
              return rgBase && cgBase && rgBase === cgBase;
            });
          });
        });

        return !isMergedIntoAnotherRow;
      });

      const attachedGroupMap = [];
      combinedRows.forEach(c => {
        const rawList = [...new Set(this.splitGroupNames(c.row.guruhNomi).map(s => s.trim()))].filter(Boolean);
        for (let i = 1; i < rawList.length; i++) {
          attachedGroupMap.push({
            groupName: rawList[i],
            parentRow: c.row
          });
        }
      });

      const injectedRows = [];
      const getClean = (s) => (s || "").replace(/\b(19|20)\d{2}\b/g, '').replace(/sirtqi|kunduzgi|kechki/gi, '').replace(/[^a-z0-9]/gi, '').toLowerCase();

      attachedGroupMap.forEach(({ groupName, parentRow }) => {
        const gClean = getClean(groupName);

        const hasExisting = filtered.some(r => {
          if (!r.guruhNomi) return false;
          if (!sameSubject(r, parentRow)) return false;
          if (!sameSemester(r, parentRow)) return false;
          if (!sameEducationForm(r, parentRow)) return false;
          const rList = this.splitGroupNames(r.guruhNomi);
          if (rList.length > 1) return false;
          return getClean(r.guruhNomi) === gClean || r.guruhNomi.trim() === groupName.trim();
        });

        const alreadyInjected = injectedRows.some(inj =>
          sameSubject(inj, parentRow) &&
          sameSemester(inj, parentRow) &&
          getClean(inj.guruhNomi) === gClean
        );

        if (!hasExisting && !alreadyInjected) {
          let sepTalaba = 20;
          const gCleanCheck = getClean(groupName);

          const exactSingleRow = this.rows.find(r => {
            if (!r.guruhNomi) return false;
            if (!sameSemester(r, parentRow)) return false;
            if (!sameEducationForm(r, parentRow)) return false;
            const parts = this.splitGroupNames(r.guruhNomi);
            if (parts.length !== 1) return false;
            return getClean(parts[0]) === gCleanCheck || parts[0].trim() === groupName.trim();
          });

          if (exactSingleRow && exactSingleRow.talabalarSoni) {
            sepTalaba = exactSingleRow.talabalarSoni;
          } else {
            const anyRowWithGroup = this.rows.find(r =>
              r.guruhNomi &&
              this.splitGroupNames(r.guruhNomi).some(g => getClean(g) === gCleanCheck)
            );
            if (anyRowWithGroup && anyRowWithGroup.talabalarSoni) {
              const parts = this.splitGroupNames(anyRowWithGroup.guruhNomi);
              if (parts.length === 1) {
                sepTalaba = anyRowWithGroup.talabalarSoni;
              } else {
                const singleGroupRow = this.rows.find(rx => {
                  if (!rx.guruhNomi || !rx.talabalarSoni) return false;
                  const rxParts = this.splitGroupNames(rx.guruhNomi);
                  return rxParts.length === 1 && getClean(rxParts[0]) === gCleanCheck;
                });
                if (singleGroupRow && singleGroupRow.talabalarSoni > 0 && singleGroupRow.talabalarSoni < anyRowWithGroup.talabalarSoni) {
                  sepTalaba = singleGroupRow.talabalarSoni;
                } else {
                  sepTalaba = Math.round(anyRowWithGroup.talabalarSoni / (parts.length || 2));
                }
              }
            }
          }

          let synthSpecialty = null;
          let synthCustomSpecialty = "";
          const groupSingleRow = this.rows.find(r => {
            if (!r.guruhNomi) return false;
            const parts = this.splitGroupNames(r.guruhNomi);
            return parts.length === 1 && (getClean(parts[0]) === gCleanCheck || parts[0].trim() === groupName.trim());
          });
          if (groupSingleRow) {
            synthSpecialty = groupSingleRow.specialty;
            synthCustomSpecialty = groupSingleRow.customSpecialty || "";
          } else {
            synthSpecialty = parentRow.specialty;
            synthCustomSpecialty = parentRow.customSpecialty || "";
          }

          injectedRows.push({
            _id: `synth_${parentRow._id || parentRow.id}_${gClean}`,
            departmentId: parentRow.departmentId,
            oquvYili: parentRow.oquvYili,
            semestrTuri: parentRow.semestrTuri,
            semester: parentRow.semester,
            subject: parentRow.subject,
            subjectDetails: parentRow.subjectDetails,
            subjectExamTypes: parentRow.subjectExamTypes,
            haftaSoni: parentRow.haftaSoni,
            specialty: synthSpecialty,
            customSpecialty: synthCustomSpecialty,
            guruhNomi: groupName,
            talabalarSoni: sepTalaba,
            maruza: 0,
            oqimSoni: 1,
            isSyntheticGroup: true
          });
        }
      });

      // Dublikatlarni oldini olish: bir xil itemId yoki yuklamaId bo'lgan qatorlarni filtrlaymiz
      const seenIds = new Set();
      const seenGroupSubjectKeys = new Set();
      const combined = [...filtered, ...injectedRows];
      return combined.filter(row => {
        const rawId = String(row._id || "");
        const stableId = row.yuklamaId
          ? String(row.yuklamaId)
          : (row.itemId ? String(row.itemId) : rawId);
        if (stableId) {
          if (seenIds.has(stableId)) return false;
          seenIds.add(stableId);
        }
        if (row.isSyntheticGroup && row.guruhNomi) {
          const sBase = getSubjectBase(row);
          const sem = row.semester?.code || row.semestrTuri || "";
          const gClean = getClean(row.guruhNomi);
          const key = `${sBase}_${sem}_${gClean}`;
          if (seenGroupSubjectKeys.has(key)) return false;
          seenGroupSubjectKeys.add(key);
        }
        return true;
      });
    },

    displayRows() {
      let finalRows = this.unfilteredDisplayRows || [];

      // 1. Kurs filtri
      if (this.filters.kurs !== '' && this.filters.kurs !== null && this.filters.kurs !== undefined) {
        finalRows = finalRows.filter(row => String(row.customKurs || this.getKurs(row)).trim() === String(this.filters.kurs).trim());
      }
      // 2. Fanlar filtri (nomi yoki kodi bo'yicha)
      if (this.filters.fan && this.filters.fan.trim()) {
        const q = this.filters.fan.toLowerCase().trim();
        finalRows = finalRows.filter(row => {
          const sName = (this.getSubjectNameDisplay(row) || "").toLowerCase();
          const sCode = (this.getSubjectCodeDisplay(row) || "").toLowerCase();
          return sName.includes(q) || sCode.includes(q);
        });
      }
      // 3. Fakultet filtri
      if (this.filters.fakultet && this.filters.fakultet.trim()) {
        const f = this.filters.fakultet.toLowerCase().trim();
        finalRows = finalRows.filter(row => {
          const fName = (row.faculty?.name || row.customFaculty || row.specialty?.name || "").toLowerCase().trim();
          return fName === f || fName.includes(f);
        });
      }
      // 4. Ta'lim yo'nalishi filtri
      if (this.filters.yonilish && this.filters.yonilish.trim()) {
        const y = this.filters.yonilish.toLowerCase().trim();
        finalRows = finalRows.filter(row => {
          const yName = (this.getRowSpecialty(row) || "").toLowerCase().trim();
          return yName === y || yName.includes(y);
        });
      }
      // 5. Guruh nomi filtri
      if (this.filters.guruh && this.filters.guruh.trim()) {
        const g = this.filters.guruh.toLowerCase().trim();
        finalRows = finalRows.filter(row => {
          const fullG = (this.getFullGuruhNomi(row) || "").toLowerCase();
          const rawG = (row.guruhNomi || "").toLowerCase();
          return fullG.includes(g) || rawG.includes(g);
        });
      }

      return finalRows;
    },

    totalRowsCount() {
      return (this.unfilteredDisplayRows || []).length;
    },

    hasActiveFilters() {
      return !!(
        (this.filters.fan && this.filters.fan.trim()) ||
        (this.filters.fakultet && this.filters.fakultet.trim()) ||
        (this.filters.yonilish && this.filters.yonilish.trim()) ||
        (this.filters.guruh && this.filters.guruh.trim()) ||
        (this.filters.kurs !== '' && this.filters.kurs !== null && this.filters.kurs !== undefined)
      );
    },

    availableCourses() {
      const set = new Set();
      (this.unfilteredDisplayRows || this.rows || []).forEach(row => {
        const k = row.customKurs || this.getKurs(row);
        if (k && k !== "—" && !isNaN(Number(k))) {
          set.add(Number(k));
        }
      });
      [1, 2, 3, 4].forEach(n => set.add(n));
      return Array.from(set).sort((a, b) => a - b);
    },

    availableFaculties() {
      const set = new Set();
      (this.unfilteredDisplayRows || this.rows || []).forEach(row => {
        const f = row.faculty?.name || row.customFaculty || "";
        if (f && f.trim() && f !== "—") {
          set.add(f.trim());
        }
      });
      return Array.from(set).sort();
    },

    availableSpecialties() {
      const set = new Set();
      (this.unfilteredDisplayRows || this.rows || []).forEach(row => {
        const sp = this.getRowSpecialty(row);
        if (sp && sp.trim() && sp !== "—") {
          sp.split(',').forEach(s => {
            if (s.trim()) set.add(s.trim());
          });
        }
      });
      return Array.from(set).sort();
    },

    availableGroupsList() {
      const set = new Set();
      (this.unfilteredDisplayRows || this.rows || []).forEach(row => {
        const fullG = this.getFullGuruhNomi(row);
        if (fullG && fullG !== "—") {
          set.add(fullG.trim());
        } else if (row.guruhNomi && row.guruhNomi.trim()) {
          this.splitGroupNames(row.guruhNomi).forEach(g => {
            if (g.trim()) set.add(g.trim());
          });
        }
      });
      return Array.from(set).sort();
    },
    guruhSpecialtyMap() {
      const map = {};
      const normalize = (str) => (str || "").replace(/\s+/g, ' ').trim().toLowerCase();

      this.rows.forEach(r => {
        if (!r.guruhNomi) return;
        const groups = this.splitGroupNames(r.guruhNomi);
        const sp = r.customSpecialty || r.specialty?.name;
        if (sp) {
          groups.forEach(g => {
            const normKey = normalize(g);
            if (!map[g] || groups.length === 1) map[g] = sp;
            if (!map[normKey] || groups.length === 1) map[normKey] = sp;
          });
        }
      });
      return map;
    },
    totals() {
      const keys = [
        "kursIshi", "kursIshiHimoya", "kursLoyihasi", "kursLoyihasiHimoya",
        "hisobChizma", "oraliq", "yakuniy", "amaliyotInd", "amaliyotUni",
        "amaliyotTash", "bmiRahbar", "bmiDak", "magistr", "mdIti", "mdDak",
        "doktorant", "yadaYozmaGuruh", "yadaYozmaTalaba", "yadaTest",
        "ochiqLeksiya", "malakaOshirish", "jamiAudit", "jamiTashqari", "jami"
      ];
      const result = {
        talabalarSoni: 0, oqimSoni: 0, guruhSoni: 0, kichikGuruhSoni: 0,
        maruza: 0, amaliy: 0, seminar: 0, laboratoriya: 0,
      };
      keys.forEach(k => result[k] = 0);
      this.displayRows.forEach(row => {
        const c = this.calc(row);
        result.talabalarSoni  += row.talabalarSoni || 0;
        result.oqimSoni       += row.oqimSoni || row.oqim || 0;
        result.guruhSoni      += row.guruhSoni || 0;
        result.kichikGuruhSoni+= row.kichikGuruhSoni || 0;
        result.maruza         += c.audit.maruza;
        result.amaliy         += c.audit.amaliy;
        result.seminar        += c.audit.seminar;
        result.laboratoriya   += c.audit.laboratoriya;
        keys.forEach(k => result[k] = Number((result[k] + (c[k] || 0)).toFixed(1)));
      });
      Object.keys(result).forEach(k => {
        result[k] = Number(result[k].toFixed(1));
      });
      return result;
    },
    remainingTotals() {
      const keys = [
        "kursIshi", "kursIshiHimoya", "kursLoyihasi", "kursLoyihasiHimoya",
        "hisobChizma", "oraliq", "yakuniy", "amaliyotInd", "amaliyotUni",
        "amaliyotTash", "bmiRahbar", "bmiDak", "magistr", "mdIti", "mdDak",
        "doktorant", "yadaYozmaGuruh", "yadaYozmaTalaba", "yadaTest",
        "ochiqLeksiya", "malakaOshirish"
      ];
      const result = {
        maruza: 0, amaliy: 0, seminar: 0, laboratoriya: 0,
        jamiAudit: 0, jamiTashqari: 0, jami: 0
      };
      keys.forEach(k => { result[k] = 0; });

      this.displayRows.forEach(row => {
        const c = this.calc(row);
        const remMaruza = this.getRemaining(row, 'maruza', c.audit ? c.audit.maruza : 0);
        const remAmaliy = this.getRemaining(row, 'amaliy', c.audit ? c.audit.amaliy : 0);
        const remSeminar = this.getRemaining(row, 'seminar', c.audit ? c.audit.seminar : 0);
        const remLaboratoriya = this.getRemaining(row, 'laboratoriya', c.audit ? c.audit.laboratoriya : 0);

        result.maruza += remMaruza;
        result.amaliy += remAmaliy;
        result.seminar += remSeminar;
        result.laboratoriya += remLaboratoriya;

        const rowAuditRem = remMaruza + remAmaliy + remSeminar + remLaboratoriya;
        result.jamiAudit += rowAuditRem;

        let rowTashqariRem = 0;
        keys.forEach(k => {
          const remK = this.getRemaining(row, k, c[k] || 0);
          result[k] += remK;
          rowTashqariRem += remK;
        });

        result.jamiTashqari += rowTashqariRem;
        result.jami += (rowAuditRem + rowTashqariRem);
      });

      Object.keys(result).forEach(k => {
        result[k] = Number(result[k].toFixed(1));
      });
      return result;
    },
    isEditable() {
      return ["Kafedra mudiri", "admin", "Super Admin"].includes(this.userRole);
    },
    isSuperAdmin() {
      return this.userRole === 'Super Admin';
    }
  },
  data() {
    return {
      userRole: "",
      loading: false,
      rows: [],
      total: 0,
      currentPage: 1,
      pageCount: 1,
      limit: 5000,
      kafedraName: "",
      filters: {
        departmentId: "",
        oquvYili: "",
        semestrTuri: "",
        semester: "",
        fan: "",
        fakultet: "",
        yonilish: "",
        guruh: "",
        kurs: "",
      },
      semesters: ["11", "12", "13", "14", "15", "16", "17", "18"],
      
      employees: [],
      teacherForm: { employeeId: "", hours: 0, isSoatbay: false },
      currentAssignments: [],
      modalTotalHours: 0,
showModal: false,
      modalTitle: "",
      editValue: "",
      inputType: "number",
      editingRow: null,
      editingField: "",
      isTashqariEdit: false,
      tashqariConfig: {},
      tashqariInputVal: 0,
      tashqariSelectVal: null,
      tashqariHafta: 0,
      tashqariGuruh: 0,
      selectedCustomWorkload: "",
      addingCustom: false,
    };
  },
  mounted() {
    try {
      const data = localStorage.getItem("user");
      if (data && data !== "undefined") {
        this.userRole = JSON.parse(data).role || "";
      }
    } catch (e) { /* ignore */ }

    const q = this.$route.query;
    this.filters.departmentId = q.departmentId || "";
    this.filters.oquvYili = q.oquvYili || "2026-2027";
    this.filters.semestrTuri = q.semestrTuri || "";
    this.filters.semester = q.semester || "";
    this.filters.kurs = q.kurs || "";
    this.filters.fan = q.fan || "";
    this.filters.fakultet = q.fakultet || "";
    this.filters.yonilish = q.yonilish || "";
    this.filters.guruh = q.guruh || "";
    this.kafedraName = q.name || "";

    if (this.filters.departmentId) {
      this.fetchData();
    }
  },
  methods: {
    getSubjectNameDisplay(r) {
      if (!r) return "";
      let name = "";
      if (r.subject) {
        if (typeof r.subject === 'object') {
          const sObj = Array.isArray(r.subject) ? r.subject[0] : r.subject;
          name = sObj?.name || sObj?.title || sObj?.subjectName || "";
        } else if (typeof r.subject === 'string' && !/^[0-9a-fA-F]{24}$/.test(r.subject) && isNaN(Number(r.subject))) {
          name = r.subject;
        }
      }
      if (!name && r.subjectDetails) {
        const sdObj = Array.isArray(r.subjectDetails) ? r.subjectDetails[0] : r.subjectDetails;
        name = sdObj?.name || sdObj?.title || sdObj?.subjectName || "";
      }
      if (!name && r.subjectName) name = r.subjectName;
      if (!name && r.customSubject) name = r.customSubject;
      if (!name && r.name) name = r.name;
      if (!name && r.fanNomi) name = r.fanNomi;

      if (!name && (r.curriculumId || r.subject)) {
        const subId = typeof r.subject === 'object' ? (r.subject?.id || r.subject?._id) : r.subject;
        const semCode = r.semester?.code || "";
        const match = (this.rows || []).find(other => {
          if (other === r) return false;
          let oName = "";
          if (other.subject && typeof other.subject === 'object') {
            const sObj = Array.isArray(other.subject) ? other.subject[0] : other.subject;
            oName = sObj?.name || sObj?.title || sObj?.subjectName || "";
          }
          if (!oName && other.subjectName) oName = other.subjectName;
          if (!oName) return false;

          if (subId && other.subject && typeof other.subject === 'object' && String(other.subject.id || other.subject._id) === String(subId)) {
            return true;
          }
          if (r.curriculumId && other.curriculumId && String(r.curriculumId) === String(other.curriculumId)) {
            if (semCode && other.semester?.code && String(semCode) === String(other.semester.code)) {
              return true;
            }
          }
          return false;
        });
        if (match) {
          if (match.subject && typeof match.subject === 'object') {
            const sObj = Array.isArray(match.subject) ? match.subject[0] : match.subject;
            name = sObj?.name || sObj?.title || sObj?.subjectName || "";
          }
          if (!name && match.subjectName) name = match.subjectName;
        }
      }

      return name || "—";
    },
    getSubjectCodeDisplay(r) {
      if (!r) return "";
      let code = "";
      if (r.subject) {
        if (typeof r.subject === 'object') {
          const sObj = Array.isArray(r.subject) ? r.subject[0] : r.subject;
          code = sObj?.code || "";
        }
      }
      if (!code && r.subjectDetails) {
        const sdObj = Array.isArray(r.subjectDetails) ? r.subjectDetails[0] : r.subjectDetails;
        code = sdObj?.code || "";
      }
      if (!code && r.subjectCode) code = r.subjectCode;
      return code;
    },
    splitGroupNames(str) {
      if (!str) return [];
      const result = [];
      let current = '';
      let depth = 0;
      const s = str.toString();
      for (let i = 0; i < s.length; i++) {
        const char = s[i];
        if (char === '(') depth++;
        else if (char === ')') depth = Math.max(0, depth - 1);
        
        if (char === ',' && depth === 0) {
          if (current.trim()) result.push(current.trim());
          current = '';
        } else {
          current += char;
        }
      }
      if (current.trim()) result.push(current.trim());
      return result;
    },
    isTeacherLocked(emp) {
      if (!emp) return false;
      return Boolean(emp.isPlanLocked);
    },
    isAssignmentLocked(assignment) {
      if (!assignment) return false;
      const emp = (this.employees || []).find(e => 
        String(e.distinct_id || e.id || e.employee_id_number || e.meta_id) === String(assignment.employeeId) ||
        (assignment.employeeName && (e.full_name === assignment.employeeName || e.name === assignment.employeeName))
      );
      if (emp && emp.isPlanLocked) return true;
      return false;
    },
    async handleSaqlash() {
      if (this.selectedTeacherIsLocked) {
        alert("O'quv ishlari bo'yicha prorektor tasdiqlagan! Ushbu o'qituvchiga yangi fan biriktirib bo'lmaydi.");
        return;
      }
      if (this.teacherForm.employeeId && this.teacherForm.hours > 0) {
        await this.assignTeacher();
      }
      this.closeModal();
    },

    async fetchEmployees() {
      try {
        const oquvYili = this.filters.oquvYili || localStorage.getItem('selectedOquvYili') || '2026-2027';
        const res = await axios.get(`${API}/employees`, { 
          params: { 
            _department: this.filters.departmentId, 
            limit: 200, 
            type: 'teacher',
            oquvYili
          }
        });
        this.employees = res.data.data.items || [];
      } catch (err) {
        console.error("Xodimlar ro'yxatini olishda xatolik", err);
      }
    },
    openTeacherModal(row, field) {
      if (!this.isEditable) return;
      this.editingRow = row;
      this.editingField = field;
      
      const calculated = this.calc(row);
      const val = (calculated.audit && calculated.audit[field] !== undefined) 
        ? calculated.audit[field] 
        : (calculated[field] || 0);
      this.modalTotalHours = val;
      
      // Set existing assignments if any
      this.currentAssignments = (row.teachers || []).filter(t => t.field === field);
      this.teacherForm = { employeeId: "", hours: 0, isSoatbay: false };
      
      this.showModal = true;
      this.fetchEmployees();
    },
    validateTeacherHours() {
      const maxAllowed = Math.max(0, this.remainingHours);
      if (this.teacherForm.hours > maxAllowed) {
        this.teacherForm.hours = maxAllowed;
      }
      if (this.teacherForm.hours < 0) {
        this.teacherForm.hours = 0;
      }
    },

    async assignTeacher() {
      if (!this.teacherForm.employeeId || !this.teacherForm.hours) return;
      
      const maxAllowed = Math.max(0, this.remainingHours);
      if (this.teacherForm.hours > maxAllowed) {
        this.teacherForm.hours = maxAllowed;
      }
      if (this.teacherForm.hours <= 0) return;

      const emp = this.employees.find(e => (e.distinct_id || e.id || e.employee_id_number) === this.teacherForm.employeeId);
      if (!emp) return;

      if (this.selectedTeacherIsLocked || this.isTeacherLocked(emp)) {
        alert("O'quv ishlari bo'yicha prorektor tasdiqlagan! Ushbu o'qituvchiga fan biriktirib bo'lmaydi.");
        return;
      }

      const newAssignment = {
        employeeId: emp.distinct_id || emp.id || emp.employee_id_number,
        employeeName: emp.full_name || emp.name,
        hours: Number(this.teacherForm.hours),
        isSoatbay: this.teacherForm.isSoatbay,
        field: this.editingField
      };

      try {
        if (!this.editingRow._id || String(this.editingRow._id).startsWith('synth_')) {
          const createData = { ...this.editingRow };
          delete createData._id;
          delete createData.id;
          delete createData.createdAt;
          delete createData.updatedAt;
          delete createData.__v;
          createData.isSyntheticGroup = true;
          const createRes = await axios.post(`${API}/kafedra-yuklamalar`, createData);
          if (createRes.data && createRes.data.data) {
            Object.assign(this.editingRow, createRes.data.data);
            this.rows.push(createRes.data.data);
          }
        }

        let currentUser = null;
        try {
          currentUser = JSON.parse(localStorage.getItem("user") || "null");
        } catch (e) {}

        const res = await axios.patch(`${API}/kafedra-taqsimot/${this.editingRow._id}/teachers`, {
          action: 'add',
          teacher: newAssignment,
          user: currentUser
        });
        
        if (res.data.success) {
          // Update local state
          if (!this.editingRow.teachers) this.editingRow.teachers = [];
          this.editingRow.teachers.push(newAssignment);
          this.currentAssignments = this.editingRow.teachers.filter(t => t.field === this.editingField);
          this.teacherForm = { employeeId: "", hours: 0, isSoatbay: false };
        }
      } catch (err) {
        console.error("O'qituvchi qo'shishda xato", err);
        alert(err.response?.data?.error || "Saqlashda xatolik yuz berdi");
      }
    },
    async removeAssignment(idx) {
      const assignment = this.currentAssignments[idx];
      if (this.isAssignmentLocked(assignment)) {
        alert("O'quv ishlari bo'yicha prorektor tasdiqlagan! Ushbu o'qituvchidan fanni olib tashlab bo'lmaydi.");
        return;
      }
      try {
        if (!this.editingRow._id || String(this.editingRow._id).startsWith('synth_')) {
          this.editingRow.teachers = (this.editingRow.teachers || []).filter(t => t !== assignment);
          this.currentAssignments = (this.editingRow.teachers || []).filter(t => t.field === this.editingField);
          return;
        }

        let currentUser = null;
        try {
          currentUser = JSON.parse(localStorage.getItem("user") || "null");
        } catch (e) {}

        const res = await axios.patch(`${API}/kafedra-taqsimot/${this.editingRow._id}/teachers`, {
          action: 'remove',
          teacher: assignment,
          user: currentUser
        });
        
        if (res.data.success) {
          // Update local state
          this.editingRow.teachers = this.editingRow.teachers.filter(t => t !== assignment);
          this.currentAssignments = this.editingRow.teachers.filter(t => t.field === this.editingField);
        }
      } catch (err) {
        console.error("O'qituvchini o'chirishda xato", err);
        alert(err.response?.data?.error || "O'chirishda xatolik yuz berdi");
      }
    },
    
    async editAssignment(idx) {
      const assignment = this.currentAssignments[idx];
      if (this.isAssignmentLocked(assignment)) {
        alert("O'quv ishlari bo'yicha prorektor tasdiqlagan! Ushbu biriktiruvni o'zgartirib bo'lmaydi.");
        return;
      }
      await this.removeAssignment(idx);
      this.teacherForm = {
        employeeId: assignment.employeeId,
        hours: assignment.hours,
        isSoatbay: assignment.isSoatbay || false
      };
    },

    getFullGuruhNomiFor(gName, spName) {
      gName = String(gName || "").trim();
      if (!gName) return "—";
      
      const normalized = gName;
      if (/\(\d{4}-\d{4}\)/.test(normalized)) {
        return normalized;
      }
      
      if (!/^\d+-\d+/.test(normalized)) {
        return normalized;
      }
      
      const match = normalized.match(/(\d{2})/);
      if (!match) return normalized;
      
      const year2 = parseInt(match[1], 10);
      const fullYear = 2000 + year2;
      const yearStr = '(' + fullYear + '-' + (fullYear + 1) + ')';
      
      let prefix = '';
      if (spName && spName.toLowerCase().includes('konchilik elektr mexanikasi')) {
        prefix = 'KEM';
      } else if (spName && spName.toLowerCase().includes('transport vositalari muhandisligi')) {
        prefix = 'TVM';
      } else {
        const getShortSpecialty = (name) => {
          if (!name) return "";
          const words = name.replace(/\(.*\)/g, '').split(/[\s\-]+/);
          let short = words.map((w) => w.charAt(0).toUpperCase()).join('');
          return short;
        };
        prefix = getShortSpecialty(spName);
        if (!prefix) prefix = normalized.replace(/\d.*$/, '').trim();
      }
      
      let suffix = '';
      if (normalized.toLowerCase().includes('sirtqi')) suffix = ' sirtqi';
      if (normalized.toLowerCase().includes('kechki')) suffix = ' kechki';
      
      return `${prefix} ${yearStr}${suffix}`.trim();
    },

    getFullGuruhNomi(row) {
      if (!row) return "—";
      
      const gName = String(row.guruhNomi || "").trim();
      
      if (gName.includes(',')) {
        return gName;
      }
      
      if (row.curriculumName && row.curriculumName.trim() !== '') {
          return row.curriculumName.trim();
      }
      
      if (!gName || gName === "—") return "—";
      
      if (/^\d+-/.test(gName)) {
        const spName = (this.getRowSpecialty ? this.getRowSpecialty(row) : (row.customSpecialty || row.specialty?.name || ""));
        return this.getFullGuruhNomiFor(gName, spName);
      }
      
      return gName;
    },

    getRowSpecialty(row) {
      if (!row) return "";
      if (row.isSyntheticGroup && row.guruhNomi) {
        const getClean = (s) => (s || "").replace(/\b(19|20)\d{2}\b/g, '').replace(/sirtqi|kunduzgi|kechki/gi, '').replace(/[^a-z0-9]/gi, '').toLowerCase();
        const gCleanCheck = getClean(row.guruhNomi);
        const singleRow = (this.rows || []).find(r => {
          if (!r.guruhNomi) return false;
          const parts = this.splitGroupNames(r.guruhNomi);
          return parts.length === 1 && (parts[0].trim() === row.guruhNomi.trim() || getClean(parts[0]) === gCleanCheck);
        });
        if (singleRow) {
          return singleRow.customSpecialty || singleRow.specialty?.name || "";
        }
      }
      if (!row.guruhNomi) return row.customSpecialty || row.specialty?.name || "";
      const groups = this.splitGroupNames(row.guruhNomi);
      if (groups.length <= 1) {
        return row.customSpecialty || row.specialty?.name || "";
      }
      const normalize = (str) => (str || "").replace(/\s+/g, ' ').trim().toLowerCase();
      const specialties = new Set();
      
      groups.forEach(gName => {
        const normKey = normalize(gName);
        const sp = this.guruhSpecialtyMap[gName] || this.guruhSpecialtyMap[normKey];
        if (sp) {
          sp.split(',').forEach(s => { if (s.trim()) specialties.add(s.trim()); });
        }
      });
      
      if (specialties.size > 0) return Array.from(specialties).join(', ');
      return row.customSpecialty || row.specialty?.name || "";
    },

    async fetchData() {
      this.loading = true;
      this.rows = [];
      try {
        const res = await axios.get(`${API}/kafedra-taqsimot`, {
          params: {
            departmentId: this.filters.departmentId,
            oquvYili: this.filters.oquvYili,
            semestrTuri: this.filters.semestrTuri,
            semester: this.filters.semester,
            page: this.currentPage,
            limit: this.limit,
          },
        });
        this.rows = res.data.data || [];
        this.rows.forEach(r => {
          if (r.guruhNomi) {
            const pCount = r.guruhNomi.split(',').map(s => s.trim()).filter(Boolean).length;
            if (pCount > 1) {
              if (!r.guruhSoni) {
                r.guruhSoni = pCount;
              }
              if (!r.kichikGuruhSoni || r.kichikGuruhSoni < pCount) {
                r.kichikGuruhSoni = pCount;
              }
            }
          }
        });
        this.total = res.data.total || 0;
        this.pageCount = Math.ceil(this.total / this.limit) || 1;
        // Secondary guruh aniqlash displayRows computed da bajariladi
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    resetFilters() {
      this.filters.fan = "";
      this.filters.fakultet = "";
      this.filters.yonilish = "";
      this.filters.guruh = "";
      this.filters.kurs = "";
    },

    getKurs(row) {
      if (!row) return "—";
      if (row.customKurs) return row.customKurs;
      if (row.kurs) return row.kurs;
      const code = Number(row.semester?.code || row.semesterCode);
      if (!code) return "—";
      if (code >= 11) return Math.ceil((code - 10) / 2);
      if (code >= 1 && code <= 10) return Math.ceil(code / 2);
      return "—";
    },
    changePage(page) {
      if (page < 1 || page > this.pageCount) return;
      this.currentPage = page;
      this.fetchData();
    },
    setSemester(value) {
      this.filters.semestrTuri = value;
      this.currentPage = 1;
      this.fetchData();
    },
    applyYearFilter() {
      this.currentPage = 1;
      this.fetchData();
    },

    async addCustomWorkload() {
      if (!this.selectedCustomWorkload) return;
      
      const optionMap = {
        amaliyotInd: "Malakaviy amaliyot individual",
        amaliyotUni: "Malakaviy amaliyot universitet hududida",
        amaliyotTash: "Malakaviy amaliyot universitetdan tashqari hududda",
        bmiRahbar: "BMI rahbarlik",
        bmiDak: "BMI/DAK",
        magistr: "Magistrlik IPF va amaliyotga rahbarlik",
        mdIti: "MD - ITI ga rahbarlik qilish",
        mdDak: "MD/DAK",
        doktorant: "Doktorantga (stajyor tadqiqotchiga) rahbarlik",
        yadaYozmaGuruh: "YaDA yozma ish guruh soni",
        yadaYozmaTalaba: "YaDA yozma ish tekshirish",
        yadaTest: "YaDA test",
        ochiqLeksiya: "Ochiq leksiya",
        malakaOshirish: "Respublika ta'lim muassasalarida markazlarida malaka oshirishlarni o'tash"
      };

      const subjectName = optionMap[this.selectedCustomWorkload] || "Qo'shimcha yuklama";
      
      this.addingCustom = true;
      try {
        const payload = {
          departmentId: this.filters.departmentId,
          oquvYili: this.filters.oquvYili,
          semestrTuri: this.filters.semestrTuri || "hammasi",
          customField: this.selectedCustomWorkload,
          subjectName: subjectName
        };

        const res = await axios.post(`${API}/kafedra-yuklamalar/custom`, payload);
        if (res.data.success) {
          // Refresh the data to show the new row
          this.fetchData();
          this.selectedCustomWorkload = "";
        }
      } catch (err) {
        console.error("Qo'shimcha yuklama qo'shishda xatolik:", err);
        alert("Xatolik yuz berdi. Iltimos qaytadan urining.");
      } finally {
        this.addingCustom = false;
      }
    },

    async confirmDeleteRow(row) {
      if (!this.isSuperAdmin) {
        alert("Sizda ushbu amalni bajarish uchun ruxsat yo'q!");
        return;
      }
      if (!confirm(`Haqiqatan ham "${this.getSubjectNameDisplay(row)}" yuklamasini o'chirmoqchimisiz?`)) {
        return;
      }
      try {
        const idToDelete = row.yuklamaId || row._id;
        const res = await axios.delete(`${API}/kafedra-yuklamalar/${idToDelete}`);
        if (res.data.success) {
          this.fetchData();
        } else {
          alert(res.data.message || "O'chirishda xatolik yuz berdi");
        }
      } catch (err) {
        console.error("Qatorni o'chirishda xatolik:", err);
        alert("Xatolik yuz berdi. Iltimos qaytadan urining.");
      }
    },

    getLoad(row, code) {
      // Nom bo'yicha kalit so'zlar va alternativ kodlar
      const nameMap = {
        "11": ["ma'ruza", "maruza", "lecture"],
        "12": ["laboratoriya", "laboratory", "lab"],
        "13": ["amaliy", "amaliyot", "practical", "practice"],
        "14": ["seminar"],
      };
      const altCodes = { "11": ["1"], "12": ["4"], "13": ["2","3"], "14": ["3","5"] };
      const keywords = nameMap[code] || [];
      const alts = altCodes[code] || [];

      const matchEntry = (tCode, tName) => {
        tCode = String(tCode || "");
        tName = String(tName || "").toLowerCase();
        return tCode === code || alts.includes(tCode) || keywords.some(k => tName.includes(k));
      };

      // 1) total_acload — HEMIS ning asosiy maydoni (snake_case: training_type, acload)
      if (row.total_acload?.length) {
        const found = row.total_acload.find(d =>
          matchEntry(d.training_type?.code, d.training_type?.name)
        );
        if (found) return found.acload || found.total_hours || 0;
      }

      // 2) subjectDetails — eski format (camelCase: trainingType, academic_load)
      if (row.subjectDetails?.length) {
        const found = row.subjectDetails.find(d =>
          matchEntry(d.trainingType?.code || d.training_type?.code,
                     d.trainingType?.name || d.training_type?.name)
        );
        if (found) return found.academic_load || found.acload || 0;
      }

      return 0;
    },


    getExam(row, type) {
      if (!row.subjectExamTypes?.length) return 0;
      const keywords = {
        oraliq: ["oraliq", "12", "1"],
        yakuniy: ["yakuniy", "final", "13", "2"],
        nazorat: ["nazorat", "3"],
      };
      const keys = keywords[type] || [];
      const found = row.subjectExamTypes.find((e) =>
        keys.some(
          (k) =>
            String(e.examType?.name).toLowerCase().includes(k) ||
            String(e.examType?.code) === k,
        ),
      );
      return found?.max_ball || 0;
    },

    getRemaining(row, field, totalVal) {
      totalVal = Number(totalVal) || 0;
      if (!row.teachers || row.teachers.length === 0) return (field === 'oraliq' || field === 'yakuniy') ? Math.round(totalVal) : totalVal;
      const assigned = row.teachers.filter(t => t.field === field).reduce((sum, t) => sum + (t.hours || 0), 0);
      const rem = totalVal - assigned;
      return (field === 'oraliq' || field === 'yakuniy') ? Math.round(rem) : Number(rem.toFixed(1));
    },

    checkIsSecondaryGroup(row) {
      if (!row || !row.guruhNomi) return false;
      const rList = row.guruhNomi.split(',').map(s => s.trim()).filter(Boolean);
      if (rList.length > 1) return false;

      const getGroupBase = (str) => (str || "").replace(/\b(19|20)\d{2}\b/g, '').replace(/sirtqi|kunduzgi|kechki/gi, '').replace(/[^a-z0-9]/gi, '').toLowerCase();
      const rGroupBase = getGroupBase(rList[0]);
      if (!rGroupBase) return false;

      const getSubjectBase = (r) => {
        if (!r) return "";
        let name = "";
        if (r.subject) {
          if (typeof r.subject === 'object') {
            const sObj = Array.isArray(r.subject) ? r.subject[0] : r.subject;
            name = sObj?.name || sObj?.title || sObj?.subjectName || "";
          } else if (typeof r.subject === 'string' && !/^[0-9a-fA-F]{24}$/.test(r.subject)) {
            name = r.subject;
          }
        }
        if (!name && r.subjectDetails) {
          const sdObj = Array.isArray(r.subjectDetails) ? r.subjectDetails[0] : r.subjectDetails;
          name = sdObj?.name || sdObj?.title || sdObj?.subjectName || "";
        }
        if (!name && r.subjectName) name = r.subjectName;
        if (!name && r.customSubject) name = r.customSubject;
        if (!name && r.name) name = r.name;
        if (!name && r.fanNomi) name = r.fanNomi;

        return (name || "")
          .replace(/\u0430/g,'a').replace(/\u0410/g,'A')
          .replace(/\u0435/g,'e').replace(/\u0415/g,'E')
          .replace(/\u043E/g,'o').replace(/\u041E/g,'O')
          .replace(/\u0441/g,'c').replace(/\u0421/g,'C')
          .replace(/\u0440/g,'r').replace(/\u0420/g,'R')
          .replace(/\u0445/g,'x').replace(/\u0425/g,'X')
          .replace(/[^a-z0-9]/gi, '').toLowerCase();
      };

      const rSubjBase = getSubjectBase(row);

      return (this.rows || []).some(c => {
        if (c === row || !c.guruhNomi) return false;
        const cList = this.splitGroupNames(c.guruhNomi);
        if (cList.length <= 1) return false;
        const cSubjBase = getSubjectBase(c);
        const matchSubj = (!rSubjBase || !cSubjBase) ? true : (rSubjBase === cSubjBase || rSubjBase.includes(cSubjBase) || cSubjBase.includes(rSubjBase));
        if (!matchSubj) return false;

        for (let i = 1; i < cList.length; i++) {
          if (getGroupBase(cList[i]) === rGroupBase) return true;
        }
        return false;
      });
    },

    calc(row) {
      const isMultiGroup = row.guruhNomi && this.splitGroupNames(row.guruhNomi).length > 1;
      const isSecGroup = !isMultiGroup && (!!row.isSyntheticGroup || !!row._isSecondaryInStream);
      const hasGuruh = !!row.guruhNomi || row.isCustom;
      const s = (typeof row.talabalarSoni === 'number' && row.talabalarSoni > 0) ? row.talabalarSoni : (hasGuruh ? (row.talabalarSoni || 0) : 0);
      const gListCount = row.guruhNomi ? this.splitGroupNames(row.guruhNomi).length : 0;
      const h = row.haftaSoni || 0;
      const name = (this.getSubjectNameDisplay(row) + " " + this.getSubjectCodeDisplay(row)).toLowerCase();
      const rgName = String(row.ratingGrade?.name || "").toLowerCase();
      const hasKursLoyihaDetail = Array.isArray(row.subjectDetails) && row.subjectDetails.some(d => String(d.trainingType?.name).toLowerCase().includes("kurs loyiha") || String(d.trainingType?.code) === "15");
      const hasKursIshiDetail = Array.isArray(row.subjectDetails) && row.subjectDetails.some(d => String(d.trainingType?.name).toLowerCase().includes("kurs ish") || String(d.trainingType?.code) === "16");
      const exactKursIshiHimoya = name.includes("kurs ish himoya") || name.includes("kurs ishi himoya");
      const exactKursIshi = (name.includes("kurs ish") || hasKursIshiDetail) && !exactKursIshiHimoya && !name.includes("kurs loyiha") && !hasKursLoyihaDetail;
      const exactKursLoyihasiHimoya = name.includes("kurs loyiha himoya") || name.includes("kurs loyihasi himoya");
      const exactKursLoyihasi = (name.includes("kurs loyiha") || name.includes("kurs-loyiha") || name.includes("kurs loyihas") || rgName.includes("kurs loyiha") || hasKursLoyihaDetail) && !exactKursLoyihasiHimoya;
      const hasAuditoryDetails = Array.isArray(row.subjectDetails) && row.subjectDetails.some(d => ["11", "13", "12", "14", "1", "2", "3", "4", "5"].includes(String(d.trainingType?.code || d.training_type?.code)));
      const isAmaliyot = !hasAuditoryDetails && (
        name.includes("malakaviy amaliyot") ||
        name.includes("o'quv amaliyot") ||
        name.includes("ishlab chiqarish amaliyot") ||
        name.includes("pedagogik amaliyot") ||
        name.includes("diplom oldi amaliyot") ||
        name.includes("praktika") ||
        (name.startsWith("amaliyot") && !name.includes("buxgalteriya"))
      );
      const isBMI = /\bbmi\b/.test(name) || name.includes("malakaviy ish");
      const isMagistr = !hasAuditoryDetails && !name.includes("avtomagistral") && name.includes("magistr");
      const isMD = name.includes("md - iti") || name.includes("md/dak");
      const isPhD = name.includes("doktorant") || name.includes("stajyor");
      const isYADA = /\byada\b/.test(name) || name.includes("yakuniy davlat");
      const isOchiqLeksiya = name.includes("ochiq leksiya");
      const isMalakaOshirish = !hasAuditoryDetails && (name.includes("malaka oshirishlarni o'tash") || name === "malaka oshirish" || name.startsWith("malaka oshirish") || (row.isCustom && name.includes("malaka oshirish")));
      // Ilmiy-pedagogik ish: oraliq va yakuniy nazorat hisoblanmaydi
      const isIlmiyPedagogik = name.includes("ilmiy-pedagogik") || name.includes("ilmiy pedagogik");
      const specName = (row.specialty?.name || "").toLowerCase();
      const isTech = specName.includes("texnik") || specName.includes("muhandis") || specName.includes("it ") || specName.includes("axborot") || specName.includes("dastur");
      const bmiMult = isTech ? 30 : 25;
      const isStajyor = name.includes("stajyor") || name.includes("tadqiqotchi");
      const phdMult = isStajyor ? 75 : 100;
      const isExtra = (row.isCustom && !row.isSyntheticGroup && !!row.customField) ||
                      exactKursIshi || exactKursIshiHimoya ||
                      exactKursLoyihasi || exactKursLoyihasiHimoya ||
                      isAmaliyot || isBMI || isMagistr || isMD || isPhD || isYADA || isOchiqLeksiya || isMalakaOshirish ||
                      name.includes("hisob-chizma");
      // Oraliq/yakuniy hisoblanmaydigan fanlar
      const noExam = isExtra || isIlmiyPedagogik;
      // Guruh yo'q bo'lsa ham HEMIS soatlarini ko'rsatish uchun multiplier 1 ga teng
      const o = row.oqimSoni || row.oqim || 1;
      const gBase = hasGuruh ? (row.guruhSoni || gListCount || 1) : 1;
      const g = hasGuruh ? gBase : 0;  // Tashqari hisob-kitoblar uchun
      const kgBase = Math.max(row.kichikGuruhSoni || 1, gBase);
      const labRaw = this.getLoad(row, "12");
      const amaliyLoad = this.getLoad(row, "13");
      const seminarLoad = this.getLoad(row, "14");
      const audit = {
        maruza:       (isExtra || isSecGroup) ? 0 : (typeof row.maruza       === 'number' && row.maruza       > 0 ? row.maruza       : Math.round(this.getLoad(row, "11") * o)),
        amaliy:       (isExtra || isSecGroup) ? 0 : Math.round((typeof row.amaliy       === 'number' && row.amaliy       > 0 ? row.amaliy       : amaliyLoad)  * gBase),
        seminar:      (isExtra || isSecGroup) ? 0 : Math.round((typeof row.seminar      === 'number' && row.seminar      > 0 ? row.seminar      : seminarLoad) * gBase),
        laboratoriya: (isExtra || isSecGroup) ? 0 : Math.round((typeof row.laboratoriya === 'number' && row.laboratoriya > 0 ? row.laboratoriya : labRaw)       * kgBase)
      };


      const res = {
        audit,
        jamiAudit: Math.round(audit.maruza + audit.amaliy + audit.seminar + audit.laboratoriya),
        kursIshi: exactKursIshi ? Math.round(s * 2) : 0,
        kursIshiHimoya: (exactKursIshi || exactKursIshiHimoya) ? Math.round(s * 0.4) : 0,
        kursLoyihasi: exactKursLoyihasi ? Math.round(s * 3) : 0,
        kursLoyihasiHimoya: (exactKursLoyihasi || exactKursLoyihasiHimoya) ? Math.round(s * 0.6) : 0,
        hisobChizma: name.includes("hisob-chizma") ? Math.round(s * 0.3) : 0,
        oraliq:  (noExam || isSecGroup) ? 0 : (s > 0 ? Math.round(s * 0.2) : 0),
        yakuniy: (noExam || isSecGroup) ? 0 : (s > 0 ? Math.round(s * 0.3) : 0),
        amaliyotInd: (!row.isCustom && isAmaliyot) || (row.isCustom && name === "malakaviy amaliyot individual") ? Math.round(s * 2) : 0,
        amaliyotUni: (!row.isCustom && isAmaliyot) || (row.isCustom && name === "malakaviy amaliyot universitet hududida") ? Math.round(3 * 6 * h * g) : 0,
        amaliyotTash: (!row.isCustom && isAmaliyot) || (row.isCustom && name === "malakaviy amaliyot universitetdan tashqari hududda") ? Math.round(6 * 6 * h * g) : 0,
        bmiRahbar: (!row.isCustom && isBMI) || (row.isCustom && name === "bmi rahbarlik") ? Math.round(s * bmiMult) : 0,
        bmiDak: (!row.isCustom && isBMI) || (row.isCustom && name === "bmi/dak") ? Math.round(s * 0.4) : 0,
        magistr: (!row.isCustom && isMagistr) || (row.isCustom && name === "magistrlik ipf va amaliyotga rahbarlik") ? Math.round(s * 50) : 0,
        mdIti: (!row.isCustom && isMD) || (row.isCustom && name === "md - iti ga rahbarlik qilish") ? Math.round(s * 50) : 0,
        mdDak: (!row.isCustom && isMD) || (row.isCustom && name === "md/dak") ? Math.round(s * 0.8) : 0,
        doktorant: (!row.isCustom && isPhD) || (row.isCustom && name === "doktorantga (stajyor tadqiqotchiga) rahbarlik") ? Math.round(s * phdMult) : 0,
        yadaYozmaGuruh: (!row.isCustom && isYADA) || (row.isCustom && name === "yada yozma ish guruh soni") ? Math.round(g * 3) : 0,
        yadaYozmaTalaba: (!row.isCustom && isYADA) || (row.isCustom && name === "yada yozma ish tekshirish") ? Math.round(s * 0.2) : 0,
        yadaTest: (!row.isCustom && isYADA) || (row.isCustom && name === "yada test") ? Math.round(g * 1) : 0,
        ochiqLeksiya: (!row.isCustom && isOchiqLeksiya) || (row.isCustom && name === "ochiq leksiya") ? Math.round(g * 5) : 0,
        malakaOshirish: (!row.isCustom && isMalakaOshirish) || (row.isCustom && (name === "respublika ta'lim muassasalarida markazlarida malaka oshirishlarni o'tash" || name.includes("malaka oshirish"))) ? (typeof row.malakaOshirish === 'number' ? row.malakaOshirish : 0) : 0
      };
      const tashqariKeys = [
        "kursIshi", "kursIshiHimoya", "kursLoyihasi", "kursLoyihasiHimoya", 
        "hisobChizma", "oraliq", "yakuniy", "amaliyotInd", "amaliyotUni", 
        "amaliyotTash", "bmiRahbar", "bmiDak", "magistr", "mdIti", "mdDak", 
        "doktorant", "yadaYozmaGuruh", "yadaYozmaTalaba", "yadaTest", "ochiqLeksiya",
        "malakaOshirish"
      ];

      // Apply manual overrides from saved row data (but NOT for secondary groups)
      if (!isSecGroup) {
        tashqariKeys.forEach(f => {
          if (typeof row[f] === 'number') {
            if ((f === 'oraliq' || f === 'yakuniy') && noExam) return;
            res[f] = row[f];
          }
        });
      }

      res.jamiTashqari = Math.round(tashqariKeys.reduce((acc, key) => acc + (res[key] || 0), 0));
      res.jami = Math.round(res.jamiAudit + res.jamiTashqari);
      
      return res;
    },

    openEditModal(row, field, title, inputType = 'number') {
      if (!this.isEditable) return;
      this.editingRow = row;
      this.editingField = field;
      this.modalTitle = title;
      if (field === 'guruhSoni') {
        const gListCount = row.guruhNomi ? row.guruhNomi.split(',').map(s => s.trim()).filter(Boolean).length : 0;
        this.editValue = row.guruhSoni || gListCount || 1;
      } else {
        this.editValue = row[field] || "";
      }
      this.inputType = inputType;
      this.isTashqariEdit = false;
      this.showModal = true;
    },

    openTashqariModal(row, field, title) {
      if (!this.isEditable) return;
      this.editingRow = row;
      this.editingField = field;
      this.modalTitle = title;
      this.isTashqariEdit = true;
      this.modalTotalHours = this.calc(row)[field] || 0;
      this.currentAssignments = (row.teachers || []).filter(t => t.field === field);
      this.teacherForm = { employeeId: "", hours: 0, isSoatbay: false };
      
      if (this.employees.length === 0) {
        this.fetchEmployees();
      }
      this.showModal = true;

      const configs = {
        kursIshi: { label: "Talabalar soni", multiplier: 2, formulaText: "Talaba soni * 2" },
        kursIshiHimoya: { label: "Talabalar soni", multiplier: 0.4, formulaText: "Talaba soni * 0.4" },
        kursLoyihasi: { label: "Talabalar soni", multiplier: 3, formulaText: "Talaba soni * 3" },
        kursLoyihasiHimoya: { label: "Talabalar soni", multiplier: 0.6, formulaText: "Talaba soni * 0.6" },
        hisobChizma: { label: "Talabalar soni", multiplier: 0.3, formulaText: "Talaba soni * 0.3" },
        oraliq: { label: "Talabalar soni", multiplier: 0.2, formulaText: "Talaba soni * 0.2" },
        yakuniy: { label: "Talabalar soni", multiplier: 0.3, formulaText: "Talaba soni * 0.3" },
        amaliyotInd: { label: "Talabalar soni", multiplier: 2, formulaText: "Talaba soni * 2" },
        amaliyotUni: { type: "multi_vars", formulaText: "3 * 6 * Hafta soni * Guruh soni", multiplier: 18 },
        amaliyotTash: { type: "multi_vars", formulaText: "6 * 6 * Hafta soni * Guruh soni", multiplier: 36 },
        bmiRahbar: {
          type: "selection",
          options: [
            { text: "Boshqa ta'lim yo'nalishlari (*25)", value: 25 },
            { text: "Texnik yo'nalishlar (*30)", value: 30 }
          ],
          label: "Talabalar soni"
        },
        bmiDak: { label: "Talabalar soni", multiplier: 0.4, formulaText: "Talaba soni * 0.4" },
        magistr: { label: "Talabalar soni", multiplier: 50, formulaText: "Talaba soni * 50" },
        mdIti: { label: "Talabalar soni", multiplier: 50, formulaText: "Talaba soni * 50" },
        mdDak: { label: "Talabalar soni", multiplier: 0.8, formulaText: "Talaba soni * 0.8" },
        doktorant: {
          type: "selection",
          options: [
            { text: "Stajyor-tadqiqotchi (*75)", value: 75 },
            { text: "Doktorant (*100)", value: 100 }
          ],
          label: "Talabalar soni"
        },
        yadaYozmaGuruh: { label: "Guruhlar soni", multiplier: 3, formulaText: "Guruh soni * 3" },
        yadaYozmaTalaba: { label: "Talabalar soni", multiplier: 0.2, formulaText: "Talaba soni * 0.2" },
        yadaTest: { label: "Guruhlar soni", multiplier: 1, formulaText: "Guruh soni * 1" },
        ochiqLeksiya: { label: "Darslar soni", multiplier: 5, formulaText: "Dars soni * 5" },
        malakaOshirish: { label: "Soat", multiplier: 1, formulaText: "Soat * 1" }
      };

      this.tashqariConfig = configs[field] || { label: "Qiymat", multiplier: 1, formulaText: "" };

      // Get current displayed value (manual override or calculated)
      const currentVal = this.calc(row)[field] || 0;

      // Initialize inputs based on the configuration type
      if (this.tashqariConfig.type === 'multi_vars') {
        this.tashqariHafta = row.haftaSoni || 0;
        this.tashqariGuruh = row.guruhSoni || 0;
      } else if (this.tashqariConfig.type === 'selection') {
        if (field === 'bmiRahbar') {
          const specName = (row.specialty?.name || "").toLowerCase();
          const isTech = specName.includes("texnik") || specName.includes("muhandis") || specName.includes("it ") || specName.includes("axborot") || specName.includes("dastur");
          this.tashqariSelectVal = (isTech || (currentVal > 0 && currentVal % 30 === 0)) ? 30 : 25;
        } else if (field === 'doktorant') {
          this.tashqariSelectVal = (currentVal > 0 && currentVal % 75 === 0) ? 75 : 100;
        } else {
          this.tashqariSelectVal = this.tashqariConfig.options[0].value;
        }
        
        if (currentVal > 0) {
          this.tashqariInputVal = Number((currentVal / this.tashqariSelectVal).toFixed(1));
        } else {
          this.tashqariInputVal = row.talabalarSoni || 0;
        }
      } else {
        const mult = this.tashqariConfig.multiplier || 1;
        if (currentVal > 0) {
          this.tashqariInputVal = Number((currentVal / mult).toFixed(1));
        } else {
          if (['yadaYozmaGuruh', 'yadaTest'].includes(field)) {
            this.tashqariInputVal = row.guruhSoni || 0;
          } else if (field === 'ochiqLeksiya' || field === 'malakaOshirish') {
            this.tashqariInputVal = 0;
          } else {
            this.tashqariInputVal = row.talabalarSoni || 0;
          }
        }
      }

      this.recalcTashqari();
      this.showModal = true;
    },

    getActiveFormulaText() {
      if (!this.tashqariConfig) return "";
      if (this.tashqariConfig.type === 'selection') {
        const selectedOpt = this.tashqariSelectVal;
        return `${this.tashqariConfig.label || 'Talaba soni'} * ${selectedOpt || 'multiplier'}`;
      }
      return this.tashqariConfig.formulaText || "";
    },

    getTashqariExpression() {
      if (!this.tashqariConfig) return "";
      if (this.tashqariConfig.type === 'multi_vars') {
        const coef = this.editingField === 'amaliyotUni' ? '3 * 6' : '6 * 6';
        return `${coef} * ${this.tashqariHafta || 0} * ${this.tashqariGuruh || 0}`;
      }
      if (this.tashqariConfig.type === 'selection') {
        return `${this.tashqariInputVal || 0} * ${this.tashqariSelectVal || 0}`;
      }
      return `${this.tashqariInputVal || 0} * ${this.tashqariConfig.multiplier || 0}`;
    },

    recalcTashqari() {
      if (!this.tashqariConfig) return;
      let res = 0;
      if (this.tashqariConfig.type === 'multi_vars') {
        res = (this.tashqariConfig.multiplier || 1) * (Number(this.tashqariHafta) || 0) * (Number(this.tashqariGuruh) || 0);
      } else if (this.tashqariConfig.type === 'selection') {
        res = (Number(this.tashqariInputVal) || 0) * (Number(this.tashqariSelectVal) || 0);
      } else {
        res = (Number(this.tashqariInputVal) || 0) * (this.tashqariConfig.multiplier || 0);
      }
      if (['oraliq', 'yakuniy'].includes(this.editingField)) {
        this.editValue = Math.round(res);
      } else {
        this.editValue = Number(res.toFixed(1));
      }
    },

    closeModal() {
      this.showModal = false;
      this.editingRow = null;
      this.editingField = "";
      this.editValue = "";
      this.isTashqariEdit = false;
    },

    async clearValue() {
      if (this.isTashqariEdit) {
        // Remove manual override, revert to formula
        this.editValue = null;
        await this.confirmValue();
        return;
      }
      this.editValue = "";
    },

    async confirmValue() {
      if (!this.editingRow || !this.editingRow._id) {
        if (this.editingRow) {
          if (this.isTashqariEdit && this.editValue === null) {
            delete this.editingRow[this.editingField];
          } else {
            const val = this.inputType === 'number' ? (this.editValue === "" ? 0 : Number(this.editValue)) : this.editValue;
            this.editingRow[this.editingField] = val;
          }
        }
        this.closeModal();
        return;
      }

      try {
        const payload = {};
        if (this.isTashqariEdit && this.editValue === null) {
          payload[this.editingField] = null;
          await axios.patch(`${API}/kafedra-taqsimot/${this.editingRow._id}`, payload);
          delete this.editingRow[this.editingField];
        } else {
          const valueToSave = this.inputType === 'number' ? (this.editValue === "" ? 0 : Number(this.editValue)) : this.editValue;
          payload[this.editingField] = valueToSave;
          await axios.patch(`${API}/kafedra-taqsimot/${this.editingRow._id}`, payload);
          this.editingRow[this.editingField] = valueToSave;
        }
        
        this.closeModal();
      } catch (err) {
        console.error("Xatolik", err);
        alert("Saqlashda xatolik yuz berdi.");
      }
    },

    exportToExcel() {
      const table = this.$refs.yuklamaTable;
      if (!table) return;

      const html = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="UTF-8">
          <style>
            table { border-collapse: collapse; font-family: sans-serif; font-size: 11px; }
            th, td { border: 1px solid #000; padding: 5px; text-align: center; vertical-align: middle; mso-number-format:"\\@"; }
            th { font-weight: bold; background-color: #f3f3f3; }
            .th-audit { background-color: #fffdf0; }
            .th-tashqari { background-color: #f0f8ff; }
            .th-jami { font-weight: bold; }
          </style>
        </head>
        <body>
          <table border="1">${table.innerHTML}</table>
        </body>
        </html>
      `;

      const blob = new Blob([html], { type: "application/vnd.ms-excel;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      
      const fileName = (this.kafedraName || "Yuklama_jadval") 
        + (this.filters.oquvYili ? "_" + this.filters.oquvYili : "")
        + ".xls";
        
      link.download = fileName.replace(/\s+/g, '_');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.teacher-modal { max-width: 600px; width: 90%; }
.summary-box { display: flex; justify-content: space-between; padding: 10px; background: #f8fafc; border-radius: 6px; margin-bottom: 10px; font-weight: 500; }
.text-red { color: #ef4444; }
.assignment-form { background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; margin-bottom: 20px; }
.row-group { display: flex; gap: 15px; align-items: flex-end; }
.flex-1 { flex: 1; }
.checkbox-container { height: 40px; display: flex; align-items: center; padding: 0 10px; }
.btn-full { width: 100%; margin-top: 15px; }
.assigned-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
.assigned-table th, .assigned-table td { border: 1px solid #e2e8f0; padding: 8px 12px; text-align: left; }
.assigned-table th { background: #f8fafc; font-weight: 600; }
.btn-delete-sm { background: #fee2e2; color: #ef4444; border: none; width: 24px; height: 24px; border-radius: 4px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px; }
.btn-delete-sm:hover { background: #fecaca; }

/* ============ Premium Teacher Modal ============ */
.tm-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center;
  animation: tmFadeIn 0.2s ease;
}
@keyframes tmFadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes tmSlideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

.tm-modal {
  width: 580px; max-width: 95vw; max-height: 90vh;
  background: #fff; border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.05);
  display: flex; flex-direction: column;
  animation: tmSlideUp 0.3s ease;
  overflow: hidden;
}

/* Header */
.tm-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 18px 24px;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  color: #fff;
}
.tm-header-left { display: flex; align-items: center; gap: 10px; }
.tm-header h3 { margin: 0; font-size: 16px; font-weight: 600; letter-spacing: -0.01em; }
.tm-close {
  width: 32px; height: 32px; border-radius: 8px; border: none;
  background: rgba(255,255,255,0.15); color: #fff;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: background 0.2s;
}
.tm-close:hover { background: rgba(255,255,255,0.3); }

/* Stats */
.tm-stats {
  display: flex; align-items: center; justify-content: center;
  padding: 14px 24px; gap: 20px;
  background: #f8fafc; border-bottom: 1px solid #e2e8f0;
}
.tm-stat-item { display: flex; align-items: center; gap: 8px; }
.tm-stat-icon { font-size: 20px; }
.tm-stat-info { display: flex; flex-direction: column; }
.tm-stat-num { font-size: 18px; font-weight: 700; color: #0f172a; line-height: 1.2; }
.tm-stat-text { font-size: 11px; color: #64748b; font-weight: 500; text-transform: uppercase; letter-spacing: 0.05em; }
.tm-stat-divider { width: 1px; height: 32px; background: #cbd5e1; }
.tm-danger { color: #ef4444; }

/* Body */
.tm-body {
  padding: 20px 24px; flex: 1; overflow-y: auto;
}
.tm-section-label {
  font-size: 12px; font-weight: 600; color: #64748b;
  text-transform: uppercase; letter-spacing: 0.05em;
  margin-bottom: 10px;
}

/* Assignment cards */
.tm-card {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 14px; margin-bottom: 8px;
  background: #f8fafc; border-radius: 10px;
  border: 1px solid #e2e8f0;
  transition: all 0.15s ease;
}
.tm-card:hover { border-color: #cbd5e1; box-shadow: 0 2px 8px rgba(0,0,0,0.04); }
.tm-card-main { display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0; }
.tm-avatar {
  width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: #fff; font-weight: 700; font-size: 15px;
  display: flex; align-items: center; justify-content: center;
}
.tm-card-info { display: flex; flex-direction: column; min-width: 0; }
.tm-card-name { font-size: 14px; font-weight: 600; color: #1e293b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tm-card-meta { font-size: 12px; color: #64748b; }
.tm-card-actions { display: flex; gap: 6px; flex-shrink: 0; }
.tm-action-btn {
  width: 32px; height: 32px; border-radius: 8px; border: none;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: all 0.15s;
}
.tm-edit { background: #fef3c7; color: #d97706; }
.tm-edit:hover { background: #fde68a; }
.tm-delete { background: #fee2e2; color: #ef4444; }
.tm-delete:hover { background: #fecaca; }
.tm-locked-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #f1f5f9;
  color: #475569;
  font-size: 11px;
  font-weight: 600;
  padding: 5px 9px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
}

/* New form */
.tm-new-form {
  background: #f8fafc; border: 1px dashed #cbd5e1; border-radius: 10px;
  padding: 16px;
}
.tm-form-row { display: flex; gap: 12px; }
.tm-form-emp { flex: 1; min-width: 0; }
.tm-form-hours { flex: 0 0 90px; }
.tm-form-group { display: flex; flex-direction: column; gap: 4px; }
.tm-label { font-size: 12px; font-weight: 600; color: #475569; }
.tm-select, .tm-input {
  width: 100%; padding: 10px 12px;
  border: 1px solid #cbd5e1; border-radius: 8px;
  font-size: 14px; color: #1e293b; background: #fff;
  outline: none; transition: all 0.2s;
}
.tm-select:focus, .tm-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,0.12);
}
.tm-form-row-bottom { margin-top: 12px; }
.tm-checkbox-wrap {
  display: flex; align-items: center; gap: 8px;
  cursor: pointer; user-select: none; font-size: 14px; color: #475569;
}
.tm-checkbox-wrap input { position: absolute; opacity: 0; width: 0; height: 0; }
.tm-check-box {
  width: 18px; height: 18px; border-radius: 5px;
  border: 2px solid #cbd5e1; background: #fff;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.2s;
}
.tm-checkbox-wrap input:checked ~ .tm-check-box {
  background: #3b82f6; border-color: #3b82f6;
}
.tm-checkbox-wrap input:checked ~ .tm-check-box::after {
  content: ''; width: 5px; height: 9px;
  border: solid #fff; border-width: 0 2px 2px 0;
  transform: rotate(45deg); margin-bottom: 2px;
}

/* Footer */
.tm-footer {
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 16px 24px; background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}
.tm-btn {
  padding: 10px 20px; border-radius: 8px; border: none;
  font-size: 14px; font-weight: 600; cursor: pointer;
  display: flex; align-items: center; gap: 6px; transition: all 0.2s;
}
.tm-btn-cancel { background: #e2e8f0; color: #475569; }
.tm-btn-cancel:hover { background: #cbd5e1; }
.tm-btn-save {
  background: linear-gradient(135deg, #3b82f6, #2563eb); color: #fff;
  box-shadow: 0 4px 12px rgba(59,130,246,0.35);
}
.tm-btn-save:hover { box-shadow: 0 6px 16px rgba(59,130,246,0.45); transform: translateY(-1px); }
.yuklama-page {
  padding: 20px;
  font-family: "Segoe UI", sans-serif;
  background: #f5f6fa;
  min-height: 100vh;
}

.custom-workload-section {
  background: #fff;
  border-top: 1px solid #e5e7eb;
  padding: 20px 24px;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cw-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}

.cw-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.cw-select {
  flex: 1;
  max-width: 400px;
}

.btn-add-custom {
  background-color: #8b5cf6;
}

.btn-add-custom:hover:not(:disabled) {
  background-color: #7c3aed;
}

.btn-add-custom:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.page-header {
  background: #f5f6fa;
  padding: 0 0 16px 0;
  margin-bottom: 0;
}

.breadcrumb {
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.3px;
}

.crumb-link {
  color: #88929c;
  cursor: pointer;
  transition: color 0.2s;
}

.crumb-link:hover {
  color: #333;
}

.separator {
  color: #d1d5db;
  font-weight: 400;
  margin: 0 2px;
}

.crumb-current {
  color: #4b5563;
}

.actions-row {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filters-group {
  display: flex;
  gap: 12px;
}

  .filter-btn {
    padding: 6px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background-color: #fff;
    color: #374151;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, border-color 0.2s;
  }

  .filter-btn.active {
    background-color: #4361ee;
    color: #fff;
    border-color: #4361ee;
  }

.filter-select {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background-color: #fff;
  font-size: 13px;
  color: #374151;
  outline: none;
  cursor: pointer;
  min-width: 160px;
}
.filter-select:focus {
  border-color: #4361ee;
  box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.1);
}

.action-buttons-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn-sync {
  background: #3b82f6; /* Slate/blue premium color */
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.2s, transform 0.1s;
}

.btn-sync:hover:not(:disabled) {
  background: #2563eb;
}

.btn-sync:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}

.spinning {
  animation: spin-sync 1s linear infinite;
}

@keyframes spin-sync {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.btn-export {
  background: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.2s;
}
.btn-export:hover {
  background: #218838;
}


.table-wrapper {
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  position: relative;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.88);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  z-index: 10;
  font-size: 14px;
  color: #666;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e0e0e0;
  border-top-color: #4361ee;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

.table-scroll {
  overflow-x: auto;
}

.yuklama-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1800px;
}

.th-base {
  background: #fff;
  color: #555;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  padding: 8px 4px;
  border: 1px solid #e8e8e8;
  font-size: 11px;
  line-height: 1.3;
}

.vertical-text {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
  margin: 0 auto;
  padding: 10px 0;
  min-height: 120px;
  display: flex;
  align-items: center;
}

.th-group {
  text-align: center;
  font-weight: 600;
  font-size: 11px;
  padding: 8px 4px;
  border: 1px solid #e8e8e8;
}

.th-audit {
  background: #fffdf0;
  color: #333;
}
.th-tashqari {
  background: #f0f8ff;
  color: #333;
}
.th-tashqari2 {
  background: #e6f7ff;
  color: #333;
}
.th-audit-cell {
  background: #fffdf0;
  color: #333;
}
.th-jami {
  background: #fffdf0;
  font-weight: 700;
}
.th-tashqari-cell {
  background: #f0f8ff;
  color: #333;
}
.th-tashqari2-cell {
  background: #e6f7ff;
  color: #333;
}

.th-num { width: 36px; }
.th-fan { width: 240px; min-width: 180px; }
.th-fak { width: 150px; min-width: 120px; }
.th-yon { width: 280px; min-width: 220px; }
.th-guruh-nomi { width: 250px; min-width: 200px; }

.data-row:hover { background: #fafafa; }

td {
  padding: 8px 6px;
  border: 1px solid #e8e8e8;
  vertical-align: middle;
  color: #333;
  font-size: 11px;
}

.totals-row td {
  font-weight: 700;
  font-size: 11px;
  line-height: 16px;
  padding: 6px 4px;
  position: sticky;
  z-index: 2;
  box-sizing: border-box;
}
.totals-row-jami td {
  bottom: 29px;
  background: #1e293b !important;
  color: #f8fafc !important;
  border-color: #334155;
}
.totals-row-jami .td-audit {
  background: #1e3a5f !important;
  color: #bfdbfe !important;
}
.totals-row-jami .td-tashqari {
  background: #1e3a2f !important;
  color: #bbf7d0 !important;
}
.totals-row-jami .td-jami-val {
  background: #4c1d95 !important;
  color: #e9d5ff !important;
}

.totals-row-remaining td {
  bottom: 0;
  background: #0f172a !important;
  color: #f8fafc !important;
  border-color: #334155;
  border-top: 1px dashed #475569 !important;
}
.totals-row-remaining .td-remaining-label {
  color: #fbbf24 !important;
  font-weight: 800;
  letter-spacing: 0.5px;
}
.totals-row-remaining .td-audit {
  background: #172554 !important;
  color: #93c5fd !important;
}
.totals-row-remaining .td-tashqari {
  background: #064e3b !important;
  color: #6ee7b7 !important;
}
.totals-row-remaining .td-jami-val {
  background: #701a75 !important;
  color: #f5d0fe !important;
}
.td-total-label {
  text-align: center;
  letter-spacing: 1px;
  font-size: 12px;
}

.td-center { text-align: center; }
.td-left { text-align: left; }
.td-num { color: #333; }
.td-fan { font-weight: 500; color: #333; white-space: normal; word-break: break-word; }
.td-yon { min-width: 220px; max-width: 360px; width: 280px; color: #555; white-space: normal; word-break: break-word; line-height: 1.4; }
.td-guruh-nomi { min-width: 200px; max-width: 320px; width: 250px; white-space: normal; word-break: break-word; text-align: center; line-height: 1.4; font-weight: 500; }
.fan-code { color: #888; font-size: 10px; font-weight: 400; }

.td-audit { background: #fffdf0; }
.td-maruza { color: #8b008b; }
.td-amaliy { color: #2e8b57; }
.td-amaliy-multiplied {
  background: #fff3cd !important;
  color: #b45309;
  font-weight: 700;
}
.td-lab-multiplied {
  background: #e8f4fd !important;
  color: #1a6da8;
  font-weight: 700;
}

.td-jami-val {
  background: #fffdf0;
  font-weight: 700;
  color: #333;
}
.td-tashqari { background: #f0f8ff; }
.td-tashqari2 { background: #e6f7ff; }

.td-empty {
  text-align: center;
  color: #aaa;
  padding: 60px;
  font-size: 14px;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f0f0;
}
.total-info { font-size: 13px; color: #888; }
.page-btns { display: flex; align-items: center; gap: 10px; }

.page-btn {
  background: #f0f0f0;
  border: none;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.2s;
}
.page-btn:hover:not(:disabled) {
  background: #28a745;
  color: #fff;
}
.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.page-info { font-size: 13px; color: #555; }

.editable-cell {
  cursor: pointer;
  transition: background 0.2s;
}
.editable-cell:hover {
  background: #e6f7ff;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 6px;
  width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #3b4559;
}

.btn-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #888;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-body label {
  font-size: 13px;
  color: #555;
  font-weight: 600;
}

.modal-input {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 6px 12px;
  width: 100px;
  font-size: 14px;
  outline: none;
  transition: border 0.2s;
}
.modal-input:focus {
  border-color: #9b59b6;
  box-shadow: 0 0 0 2px rgba(155, 89, 182, 0.2);
}

.modal-footer {
  padding: 16px 20px;
  display: flex;
  gap: 12px;
}

.btn-clear {
  background: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
}

.btn-confirm {
  background: #2ecc71;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
}

/* Custom Tashqari Formula Modal Styling */
.modal-content.modal-tashqari {
  width: 460px;
}

.tashqari-body {
  display: flex;
  flex-direction: column;
  align-items: stretch !important;
  gap: 16px;
  padding: 24px;
}

.formula-info {
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.formula-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.formula-code {
  font-family: Consolas, Monaco, monospace;
  font-size: 13px;
  color: #4f46e5;
  background: #eeebff;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: bold;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 13px;
  color: #475569;
  font-weight: 600;
}

.selection-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.selection-group {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 12px;
}

.radio-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.radio-label {
  font-size: 13px !important;
  color: #334155 !important;
  font-weight: normal !important;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.radio-label input {
  cursor: pointer;
  accent-color: #4f46e5;
}

.multi-inputs {
  display: flex;
  gap: 16px;
}

.multi-inputs .form-group {
  flex: 1;
}

.tashqari-body .modal-input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}

.tashqari-body .modal-input:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}

.calc-preview {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 6px;
  padding: 12px;
  margin-top: 4px;
}

.preview-title {
  display: block;
  font-size: 11px;
  color: #166534;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.preview-expr {
  font-size: 14px;
  color: #1e293b;
}

.preview-total-val {
  color: #15803d;
  font-size: 16px;
}

.btn-delete-row {
  background: #ef4444;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  width: 20px;
  height: 20px;
  line-height: 18px;
  text-align: center;
  font-size: 11px;
  cursor: pointer;
  margin-right: 8px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-delete-row:hover {
  background: #dc2626;
}
.row-secondary {
  /* background-color: #fff9db !important; Soft yellow for secondary groups */
}
.row-primary {
  /* background-color: #f0fdf4 !important; Soft green for primary stream rows */
}

/* ============ FILTRLAR PANELI STYLES ============ */
.table-filters-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}

.filter-field-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-field-item.grow-item {
  flex: 1;
  min-width: 180px;
}

.filter-field-label {
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  display: flex;
  align-items: center;
  gap: 4px;
}

.filter-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 10px;
  color: #94a3b8;
  pointer-events: none;
}

.filter-text-input {
  width: 100%;
  padding: 7px 28px 7px 30px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 12px;
  color: #1e293b;
  outline: none;
  background: #f8fafc;
  transition: all 0.15s ease;
}

.filter-text-input:focus {
  background: #ffffff;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.filter-clear-icon-btn {
  position: absolute;
  right: 6px;
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 2px 5px;
  font-size: 12px;
  border-radius: 4px;
}

.filter-clear-icon-btn:hover {
  color: #ef4444;
  background: #fee2e2;
}

.filter-select-control {
  padding: 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 12px;
  color: #1e293b;
  outline: none;
  background: #f8fafc;
  cursor: pointer;
  min-width: 140px;
  max-width: 200px;
  transition: all 0.15s ease;
}

.filter-select-control:focus {
  background: #ffffff;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.kurs-pills-container {
  display: flex;
  gap: 4px;
  background: #f1f5f9;
  padding: 3px;
  border-radius: 7px;
  border: 1px solid #e2e8f0;
}

.kurs-pill-btn {
  padding: 4px 9px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  background: transparent;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.kurs-pill-btn:hover {
  color: #1e40af;
  background: rgba(255, 255, 255, 0.6);
}

.kurs-pill-btn.active {
  color: #ffffff;
  background: #2563eb;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.25);
}

.btn-reset-all-filters {
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #dc2626;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.15s ease;
  height: 33px;
}

.btn-reset-all-filters:hover {
  background: #fee2e2;
  border-color: #f87171;
  color: #b91c1c;
}

.filter-count-badge {
  margin-left: auto;
  font-size: 12px;
  color: #64748b;
  padding: 6px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  white-space: nowrap;
  align-self: center;
}

.filter-count-badge strong {
  color: #1d4ed8;
}

.th-filtered {
  background: #dbeafe !important;
  color: #1e40af !important;
  border-bottom: 2px solid #3b82f6 !important;
}
</style>
